// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js!./assets/css/animation.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/img/Background_Default_1.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/img/Background_Special.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/public/img/badges/astronaut.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/public/img/badges/background.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("/public/img/badges/more_badges.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("/public/img/exam-result/banner.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("/public/img/exam-result/boy-figure.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("/public/img/exam-result/bubble.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("/public/img/exam-result/jc-banner.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("/src/assets/background/Background_Default_1.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.3.6 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
*/

html {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  -o-tab-size: 4;
     tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
.container {
  width: 100%;
}
@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}
@media (min-width: 743px) {

  .container {
    max-width: 743px;
  }
}
@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1366px) {

  .container {
    max-width: 1366px;
  }
}
.pointer-events-none {
  pointer-events: none;
}
.visible {
  visibility: visible;
}
.invisible {
  visibility: hidden;
}
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.\\!top-\\[3\\.1rem\\] {
  top: 3.1rem !important;
}
.-bottom-\\[12px\\] {
  bottom: -12px;
}
.-left-4 {
  left: -1rem;
}
.-left-\\[18px\\] {
  left: -18px;
}
.-right-\\[138px\\] {
  right: -138px;
}
.-right-\\[4px\\] {
  right: -4px;
}
.-right-\\[50px\\] {
  right: -50px;
}
.-right-\\[83px\\] {
  right: -83px;
}
.-top-0 {
  top: -0px;
}
.-top-0\\.5 {
  top: -0.125rem;
}
.-top-\\[4px\\] {
  top: -4px;
}
.-top-\\[5px\\] {
  top: -5px;
}
.bottom-0 {
  bottom: 0px;
}
.bottom-1 {
  bottom: 0.25rem;
}
.bottom-8 {
  bottom: 2rem;
}
.bottom-\\[-34px\\] {
  bottom: -34px;
}
.bottom-\\[24px\\] {
  bottom: 24px;
}
.bottom-\\[80px\\] {
  bottom: 80px;
}
.left-0 {
  left: 0px;
}
.left-1\\/2 {
  left: 50%;
}
.left-4 {
  left: 1rem;
}
.left-6 {
  left: 1.5rem;
}
.left-\\[0px\\] {
  left: 0px;
}
.left-\\[10px\\] {
  left: 10px;
}
.left-\\[17px\\] {
  left: 17px;
}
.left-\\[20px\\] {
  left: 20px;
}
.right-0 {
  right: 0px;
}
.right-2 {
  right: 0.5rem;
}
.right-2\\.5 {
  right: 0.625rem;
}
.right-4 {
  right: 1rem;
}
.right-6 {
  right: 1.5rem;
}
.right-\\[-140px\\] {
  right: -140px;
}
.right-\\[-20px\\] {
  right: -20px;
}
.right-\\[-220px\\] {
  right: -220px;
}
.right-\\[-8px\\] {
  right: -8px;
}
.right-\\[150px\\] {
  right: 150px;
}
.right-\\[30px\\] {
  right: 30px;
}
.right-\\[33px\\] {
  right: 33px;
}
.right-\\[36px\\] {
  right: 36px;
}
.right-\\[38px\\] {
  right: 38px;
}
.top-0 {
  top: 0px;
}
.top-1\\/2 {
  top: 50%;
}
.top-1\\/3 {
  top: 33.333333%;
}
.top-10 {
  top: 2.5rem;
}
.top-11 {
  top: 2.75rem;
}
.top-2 {
  top: 0.5rem;
}
.top-3 {
  top: 0.75rem;
}
.top-6 {
  top: 1.5rem;
}
.top-8 {
  top: 2rem;
}
.top-\\[-25px\\] {
  top: -25px;
}
.top-\\[10px\\] {
  top: 10px;
}
.top-\\[20vh\\] {
  top: 20vh;
}
.top-\\[30px\\] {
  top: 30px;
}
.top-\\[35px\\] {
  top: 35px;
}
.top-\\[36px\\] {
  top: 36px;
}
.top-\\[40px\\] {
  top: 40px;
}
.top-\\[46px\\] {
  top: 46px;
}
.top-\\[4px\\] {
  top: 4px;
}
.top-\\[50vh\\] {
  top: 50vh;
}
.top-\\[55px\\] {
  top: 55px;
}
.top-\\[60px\\] {
  top: 60px;
}
.top-\\[65px\\] {
  top: 65px;
}
.top-\\[70px\\] {
  top: 70px;
}
.top-\\[72px\\] {
  top: 72px;
}
.top-\\[80px\\] {
  top: 80px;
}
.top-\\[84px\\] {
  top: 84px;
}
.top-\\[8px\\] {
  top: 8px;
}
.top-\\[9px\\] {
  top: 9px;
}
.isolate {
  isolation: isolate;
}
.\\!z-\\[101\\] {
  z-index: 101 !important;
}
.-z-10 {
  z-index: -10;
}
.z-0 {
  z-index: 0;
}
.z-10 {
  z-index: 10;
}
.z-100 {
  z-index: 100;
}
.z-20 {
  z-index: 20;
}
.z-30 {
  z-index: 30;
}
.z-\\[1000\\] {
  z-index: 1000;
}
.z-\\[101\\] {
  z-index: 101;
}
.z-\\[18\\] {
  z-index: 18;
}
.z-\\[19\\] {
  z-index: 19;
}
.z-\\[1\\] {
  z-index: 1;
}
.z-\\[2\\] {
  z-index: 2;
}
.z-\\[999\\] {
  z-index: 999;
}
.z-\\[99\\] {
  z-index: 99;
}
.float-right {
  float: right;
}
.float-left {
  float: left;
}
.clear-both {
  clear: both;
}
.m-auto {
  margin: auto;
}
.-mx-4 {
  margin-left: -1rem;
  margin-right: -1rem;
}
.-mx-5 {
  margin-left: -1.25rem;
  margin-right: -1.25rem;
}
.-mx-6 {
  margin-left: -1.5rem;
  margin-right: -1.5rem;
}
.-my-4 {
  margin-top: -1rem;
  margin-bottom: -1rem;
}
.mx-3 {
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}
.mx-6 {
  margin-left: 1.5rem;
  margin-right: 1.5rem;
}
.mx-\\[0px\\] {
  margin-left: 0px;
  margin-right: 0px;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-10 {
  margin-top: 2.5rem;
  margin-bottom: 2.5rem;
}
.my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-3 {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.my-\\[31px\\] {
  margin-top: 31px;
  margin-bottom: 31px;
}
.my-auto {
  margin-top: auto;
  margin-bottom: auto;
}
.\\!ml-0 {
  margin-left: 0px !important;
}
.\\!mt-2 {
  margin-top: 0.5rem !important;
}
.-mb-3 {
  margin-bottom: -0.75rem;
}
.-mb-4 {
  margin-bottom: -1rem;
}
.-mb-\\[10px\\] {
  margin-bottom: -10px;
}
.-mb-\\[9px\\] {
  margin-bottom: -9px;
}
.-ml-2 {
  margin-left: -0.5rem;
}
.-ml-4 {
  margin-left: -1rem;
}
.-mr-4 {
  margin-right: -1rem;
}
.-mt-6 {
  margin-top: -1.5rem;
}
.-mt-\\[21px\\] {
  margin-top: -21px;
}
.mb-0 {
  margin-bottom: 0px;
}
.mb-0\\.5 {
  margin-bottom: 0.125rem;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-10 {
  margin-bottom: 2.5rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-3\\.5 {
  margin-bottom: 0.875rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-7 {
  margin-bottom: 1.75rem;
}
.mb-8 {
  margin-bottom: 2rem;
}
.mb-\\[16px\\] {
  margin-bottom: 16px;
}
.mb-\\[17px\\] {
  margin-bottom: 17px;
}
.mb-\\[19px\\] {
  margin-bottom: 19px;
}
.mb-\\[20px\\] {
  margin-bottom: 20px;
}
.mb-\\[24px\\] {
  margin-bottom: 24px;
}
.mb-\\[26px\\] {
  margin-bottom: 26px;
}
.mb-\\[30px\\] {
  margin-bottom: 30px;
}
.mb-\\[32px\\] {
  margin-bottom: 32px;
}
.mb-\\[33px\\] {
  margin-bottom: 33px;
}
.mb-\\[6px\\] {
  margin-bottom: 6px;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-10 {
  margin-left: 2.5rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-3 {
  margin-left: 0.75rem;
}
.ml-4 {
  margin-left: 1rem;
}
.ml-6 {
  margin-left: 1.5rem;
}
.ml-\\[-30px\\] {
  margin-left: -30px;
}
.ml-\\[12px\\] {
  margin-left: 12px;
}
.ml-\\[16px\\] {
  margin-left: 16px;
}
.ml-\\[24px\\] {
  margin-left: 24px;
}
.ml-auto {
  margin-left: auto;
}
.mr-0 {
  margin-right: 0px;
}
.mr-0\\.5 {
  margin-right: 0.125rem;
}
.mr-1 {
  margin-right: 0.25rem;
}
.mr-1\\.5 {
  margin-right: 0.375rem;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-3 {
  margin-right: 0.75rem;
}
.mr-4 {
  margin-right: 1rem;
}
.mr-6 {
  margin-right: 1.5rem;
}
.mr-8 {
  margin-right: 2rem;
}
.mr-\\[24px\\] {
  margin-right: 24px;
}
.mr-\\[2px\\] {
  margin-right: 2px;
}
.mr-\\[30px\\] {
  margin-right: 30px;
}
.mr-\\[4px\\] {
  margin-right: 4px;
}
.mr-auto {
  margin-right: auto;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-12 {
  margin-top: 3rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-7 {
  margin-top: 1.75rem;
}
.mt-8 {
  margin-top: 2rem;
}
.mt-\\[-15px\\] {
  margin-top: -15px;
}
.mt-\\[-16px\\] {
  margin-top: -16px;
}
.mt-\\[-18px\\] {
  margin-top: -18px;
}
.mt-\\[-23px\\] {
  margin-top: -23px;
}
.mt-\\[-2px\\] {
  margin-top: -2px;
}
.mt-\\[-30px\\] {
  margin-top: -30px;
}
.mt-\\[-35px\\] {
  margin-top: -35px;
}
.mt-\\[-3px\\] {
  margin-top: -3px;
}
.mt-\\[-5px\\] {
  margin-top: -5px;
}
.mt-\\[-8px\\] {
  margin-top: -8px;
}
.mt-\\[10px\\] {
  margin-top: 10px;
}
.mt-\\[12px\\] {
  margin-top: 12px;
}
.mt-\\[16px\\] {
  margin-top: 16px;
}
.mt-\\[20px\\] {
  margin-top: 20px;
}
.mt-\\[21px\\] {
  margin-top: 21px;
}
.mt-\\[24px\\] {
  margin-top: 24px;
}
.mt-\\[2px\\] {
  margin-top: 2px;
}
.mt-\\[40px\\] {
  margin-top: 40px;
}
.mt-\\[4px\\] {
  margin-top: 4px;
}
.mt-\\[5px\\] {
  margin-top: 5px;
}
.mt-auto {
  margin-top: auto;
}
.line-clamp-2 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.\\!block {
  display: block !important;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.inline {
  display: inline;
}
.\\!flex {
  display: flex !important;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.list-item {
  display: list-item;
}
.hidden {
  display: none;
}
.\\!h-9 {
  height: 2.25rem !important;
}
.\\!h-\\[30px\\] {
  height: 30px !important;
}
.\\!h-\\[34px\\] {
  height: 34px !important;
}
.\\!h-\\[38px\\] {
  height: 38px !important;
}
.\\!h-\\[56px\\] {
  height: 56px !important;
}
.\\!h-\\[calc\\(100vh-68px\\)\\] {
  height: calc(100vh - 68px) !important;
}
.\\!h-auto {
  height: auto !important;
}
.\\!h-fit {
  height: -moz-fit-content !important;
  height: fit-content !important;
}
.h-0 {
  height: 0px;
}
.h-1 {
  height: 0.25rem;
}
.h-10 {
  height: 2.5rem;
}
.h-12 {
  height: 3rem;
}
.h-2 {
  height: 0.5rem;
}
.h-2\\.5 {
  height: 0.625rem;
}
.h-3 {
  height: 0.75rem;
}
.h-3\\.5 {
  height: 0.875rem;
}
.h-4 {
  height: 1rem;
}
.h-5 {
  height: 1.25rem;
}
.h-6 {
  height: 1.5rem;
}
.h-8 {
  height: 2rem;
}
.h-\\[100\\%\\] {
  height: 100%;
}
.h-\\[102px\\] {
  height: 102px;
}
.h-\\[108px\\] {
  height: 108px;
}
.h-\\[11px\\] {
  height: 11px;
}
.h-\\[120px\\] {
  height: 120px;
}
.h-\\[125px\\] {
  height: 125px;
}
.h-\\[130px\\] {
  height: 130px;
}
.h-\\[14px\\] {
  height: 14px;
}
.h-\\[150px\\] {
  height: 150px;
}
.h-\\[157px\\] {
  height: 157px;
}
.h-\\[16px\\] {
  height: 16px;
}
.h-\\[1px\\] {
  height: 1px;
}
.h-\\[20px\\] {
  height: 20px;
}
.h-\\[213px\\] {
  height: 213px;
}
.h-\\[246px\\] {
  height: 246px;
}
.h-\\[24px\\] {
  height: 24px;
}
.h-\\[250px\\] {
  height: 250px;
}
.h-\\[274px\\] {
  height: 274px;
}
.h-\\[28px\\] {
  height: 28px;
}
.h-\\[294px\\] {
  height: 294px;
}
.h-\\[313px\\] {
  height: 313px;
}
.h-\\[350px\\] {
  height: 350px;
}
.h-\\[35px\\] {
  height: 35px;
}
.h-\\[37px\\] {
  height: 37px;
}
.h-\\[388px\\] {
  height: 388px;
}
.h-\\[45px\\] {
  height: 45px;
}
.h-\\[498px\\] {
  height: 498px;
}
.h-\\[525px\\] {
  height: 525px;
}
.h-\\[60px\\] {
  height: 60px;
}
.h-\\[64px\\] {
  height: 64px;
}
.h-\\[68px\\] {
  height: 68px;
}
.h-\\[70px\\] {
  height: 70px;
}
.h-\\[710px\\] {
  height: 710px;
}
.h-\\[72px\\] {
  height: 72px;
}
.h-\\[78px\\] {
  height: 78px;
}
.h-\\[80px\\] {
  height: 80px;
}
.h-\\[86px\\] {
  height: 86px;
}
.h-\\[88px\\] {
  height: 88px;
}
.h-\\[90px\\] {
  height: 90px;
}
.h-\\[928px\\] {
  height: 928px;
}
.h-\\[95\\%\\] {
  height: 95%;
}
.h-\\[96px\\] {
  height: 96px;
}
.h-\\[calc\\(\\(100\\*var\\(--vh\\2c vh\\)\\)-64px\\)\\] {
  height: calc((100 * var(--vh,vh)) - 64px);
}
.h-\\[calc\\(100\\%-28px\\)\\] {
  height: calc(100% - 28px);
}
.h-\\[calc\\(100\\%-64px\\)\\] {
  height: calc(100% - 64px);
}
.h-\\[calc\\(100svh-68px\\)\\] {
  height: calc(100svh - 68px);
}
.h-\\[calc\\(100vh-300px\\)\\] {
  height: calc(100vh - 300px);
}
.h-\\[calc\\(100vh-400px\\)\\] {
  height: calc(100vh - 400px);
}
.h-\\[calc\\(100vh-500px\\)\\] {
  height: calc(100vh - 500px);
}
.h-\\[calc\\(100vh-68px\\)\\] {
  height: calc(100vh - 68px);
}
.h-fit {
  height: -moz-fit-content;
  height: fit-content;
}
.h-full {
  height: 100%;
}
.h-screen {
  height: 100vh;
}
.max-h-5 {
  max-height: 1.25rem;
}
.max-h-\\[200px\\] {
  max-height: 200px;
}
.max-h-\\[27px\\] {
  max-height: 27px;
}
.max-h-\\[348px\\] {
  max-height: 348px;
}
.max-h-\\[365px\\] {
  max-height: 365px;
}
.max-h-\\[80vh\\] {
  max-height: 80vh;
}
.max-h-\\[calc\\(100\\%-50px\\)\\] {
  max-height: calc(100% - 50px);
}
.max-h-\\[calc\\(100vh-100px\\)\\] {
  max-height: calc(100vh - 100px);
}
.max-h-\\[calc\\(100vh-116px\\)\\] {
  max-height: calc(100vh - 116px);
}
.max-h-full {
  max-height: 100%;
}
.min-h-\\[150px\\] {
  min-height: 150px;
}
.min-h-\\[24px\\] {
  min-height: 24px;
}
.min-h-\\[250px\\] {
  min-height: 250px;
}
.min-h-\\[700px\\] {
  min-height: 700px;
}
.min-h-\\[96px\\] {
  min-height: 96px;
}
.min-h-full {
  min-height: 100%;
}
.min-h-screen {
  min-height: 100vh;
}
.\\!w-\\[124px\\] {
  width: 124px !important;
}
.\\!w-\\[14px\\] {
  width: 14px !important;
}
.\\!w-\\[calc\\(100\\%-16px\\)\\] {
  width: calc(100% - 16px) !important;
}
.\\!w-full {
  width: 100% !important;
}
.w-1 {
  width: 0.25rem;
}
.w-1\\/2 {
  width: 50%;
}
.w-1\\/3 {
  width: 33.333333%;
}
.w-1\\/6 {
  width: 16.666667%;
}
.w-10 {
  width: 2.5rem;
}
.w-10\\/12 {
  width: 83.333333%;
}
.w-11\\/12 {
  width: 91.666667%;
}
.w-2 {
  width: 0.5rem;
}
.w-2\\.5 {
  width: 0.625rem;
}
.w-2\\/12 {
  width: 16.666667%;
}
.w-20 {
  width: 5rem;
}
.w-24 {
  width: 6rem;
}
.w-3 {
  width: 0.75rem;
}
.w-3\\.5 {
  width: 0.875rem;
}
.w-32 {
  width: 8rem;
}
.w-4 {
  width: 1rem;
}
.w-5 {
  width: 1.25rem;
}
.w-5\\/12 {
  width: 41.666667%;
}
.w-5\\/6 {
  width: 83.333333%;
}
.w-56 {
  width: 14rem;
}
.w-6 {
  width: 1.5rem;
}
.w-7 {
  width: 1.75rem;
}
.w-8 {
  width: 2rem;
}
.w-8\\/12 {
  width: 66.666667%;
}
.w-\\[10\\%\\] {
  width: 10%;
}
.w-\\[10px\\] {
  width: 10px;
}
.w-\\[110px\\] {
  width: 110px;
}
.w-\\[11px\\] {
  width: 11px;
}
.w-\\[12\\%\\] {
  width: 12%;
}
.w-\\[120px\\] {
  width: 120px;
}
.w-\\[122px\\] {
  width: 122px;
}
.w-\\[126px\\] {
  width: 126px;
}
.w-\\[127px\\] {
  width: 127px;
}
.w-\\[136px\\] {
  width: 136px;
}
.w-\\[14px\\] {
  width: 14px;
}
.w-\\[15\\%\\] {
  width: 15%;
}
.w-\\[150px\\] {
  width: 150px;
}
.w-\\[155px\\] {
  width: 155px;
}
.w-\\[165px\\] {
  width: 165px;
}
.w-\\[16px\\] {
  width: 16px;
}
.w-\\[187px\\] {
  width: 187px;
}
.w-\\[18px\\] {
  width: 18px;
}
.w-\\[20\\%\\] {
  width: 20%;
}
.w-\\[20px\\] {
  width: 20px;
}
.w-\\[21\\] {
  width: 21;
}
.w-\\[240px\\] {
  width: 240px;
}
.w-\\[250px\\] {
  width: 250px;
}
.w-\\[254px\\] {
  width: 254px;
}
.w-\\[258px\\] {
  width: 258px;
}
.w-\\[262px\\] {
  width: 262px;
}
.w-\\[275px\\] {
  width: 275px;
}
.w-\\[276px\\] {
  width: 276px;
}
.w-\\[28px\\] {
  width: 28px;
}
.w-\\[3\\%\\] {
  width: 3%;
}
.w-\\[30\\%\\] {
  width: 30%;
}
.w-\\[315px\\] {
  width: 315px;
}
.w-\\[320px\\] {
  width: 320px;
}
.w-\\[326px\\] {
  width: 326px;
}
.w-\\[33\\%\\] {
  width: 33%;
}
.w-\\[340px\\] {
  width: 340px;
}
.w-\\[355px\\] {
  width: 355px;
}
.w-\\[372px\\] {
  width: 372px;
}
.w-\\[378px\\] {
  width: 378px;
}
.w-\\[37px\\] {
  width: 37px;
}
.w-\\[38px\\] {
  width: 38px;
}
.w-\\[405px\\] {
  width: 405px;
}
.w-\\[456px\\] {
  width: 456px;
}
.w-\\[469px\\] {
  width: 469px;
}
.w-\\[47\\%\\] {
  width: 47%;
}
.w-\\[5\\%\\] {
  width: 5%;
}
.w-\\[50\\%\\] {
  width: 50%;
}
.w-\\[52px\\] {
  width: 52px;
}
.w-\\[6\\%\\] {
  width: 6%;
}
.w-\\[60px\\] {
  width: 60px;
}
.w-\\[65\\%\\] {
  width: 65%;
}
.w-\\[70\\%\\] {
  width: 70%;
}
.w-\\[70vh\\] {
  width: 70vh;
}
.w-\\[76px\\] {
  width: 76px;
}
.w-\\[8\\%\\] {
  width: 8%;
}
.w-\\[80px\\] {
  width: 80px;
}
.w-\\[88px\\] {
  width: 88px;
}
.w-\\[90\\%\\] {
  width: 90%;
}
.w-\\[928px\\] {
  width: 928px;
}
.w-\\[95\\%\\] {
  width: 95%;
}
.w-\\[96px\\] {
  width: 96px;
}
.w-\\[calc\\(100\\%\\*512\\/1099\\)\\] {
  width: calc(100% * 512 / 1099);
}
.w-\\[calc\\(100\\%\\*560\\/1099\\)\\] {
  width: calc(100% * 560 / 1099);
}
.w-auto {
  width: auto;
}
.w-fit {
  width: -moz-fit-content;
  width: fit-content;
}
.w-full {
  width: 100%;
}
.w-max {
  width: -moz-max-content;
  width: max-content;
}
.w-screen {
  width: 100vw;
}
.min-w-0 {
  min-width: 0px;
}
.min-w-\\[14px\\] {
  min-width: 14px;
}
.min-w-\\[32px\\] {
  min-width: 32px;
}
.min-w-\\[44px\\] {
  min-width: 44px;
}
.min-w-\\[530px\\] {
  min-width: 530px;
}
.min-w-\\[60px\\] {
  min-width: 60px;
}
.min-w-\\[80px\\] {
  min-width: 80px;
}
.min-w-\\[96px\\] {
  min-width: 96px;
}
.min-w-full {
  min-width: 100%;
}
.\\!max-w-\\[100\\%\\] {
  max-width: 100% !important;
}
.\\!max-w-\\[240px\\] {
  max-width: 240px !important;
}
.\\!max-w-\\[300px\\] {
  max-width: 300px !important;
}
.\\!max-w-\\[450px\\] {
  max-width: 450px !important;
}
.\\!max-w-\\[460px\\] {
  max-width: 460px !important;
}
.\\!max-w-\\[462px\\] {
  max-width: 462px !important;
}
.\\!max-w-\\[463px\\] {
  max-width: 463px !important;
}
.\\!max-w-\\[512px\\] {
  max-width: 512px !important;
}
.\\!max-w-\\[560px\\] {
  max-width: 560px !important;
}
.\\!max-w-\\[calc\\(100\\%-2px\\)\\] {
  max-width: calc(100% - 2px) !important;
}
.\\!max-w-\\[calc\\(100\\%-32px\\)\\] {
  max-width: calc(100% - 32px) !important;
}
.\\!max-w-full {
  max-width: 100% !important;
}
.\\!max-w-none {
  max-width: none !important;
}
.max-w-\\[100\\%\\] {
  max-width: 100%;
}
.max-w-\\[126px\\] {
  max-width: 126px;
}
.max-w-\\[1366px\\] {
  max-width: 1366px;
}
.max-w-\\[200px\\] {
  max-width: 200px;
}
.max-w-\\[20px\\] {
  max-width: 20px;
}
.max-w-\\[250px\\] {
  max-width: 250px;
}
.max-w-\\[280px\\] {
  max-width: 280px;
}
.max-w-\\[300px\\] {
  max-width: 300px;
}
.max-w-\\[336px\\] {
  max-width: 336px;
}
.max-w-\\[340px\\] {
  max-width: 340px;
}
.max-w-\\[343px\\] {
  max-width: 343px;
}
.max-w-\\[352px\\] {
  max-width: 352px;
}
.max-w-\\[363px\\] {
  max-width: 363px;
}
.max-w-\\[378px\\] {
  max-width: 378px;
}
.max-w-\\[400px\\] {
  max-width: 400px;
}
.max-w-\\[40px\\] {
  max-width: 40px;
}
.max-w-\\[450px\\] {
  max-width: 450px;
}
.max-w-\\[675px\\] {
  max-width: 675px;
}
.max-w-\\[80\\%\\] {
  max-width: 80%;
}
.max-w-\\[90\\%\\] {
  max-width: 90%;
}
.max-w-\\[calc\\(100\\%-10px\\)\\] {
  max-width: calc(100% - 10px);
}
.max-w-\\[unset\\] {
  max-width: unset;
}
.max-w-fit {
  max-width: -moz-fit-content;
  max-width: fit-content;
}
.max-w-full {
  max-width: 100%;
}
.max-w-none {
  max-width: none;
}
.max-w-screen-sm {
  max-width: 640px;
}
.flex-1 {
  flex: 1 1 0%;
}
.flex-auto {
  flex: 1 1 auto;
}
.flex-initial {
  flex: 0 1 auto;
}
.flex-none {
  flex: none;
}
.flex-shrink {
  flex-shrink: 1;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.shrink-0 {
  flex-shrink: 0;
}
.flex-grow {
  flex-grow: 1;
}
.flex-grow-0 {
  flex-grow: 0;
}
.grow {
  flex-grow: 1;
}
.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-\\[80px\\] {
  --tw-translate-x: -80px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-1\\/2 {
  --tw-translate-x: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[40px\\] {
  --tw-translate-x: 40px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-90 {
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45 {
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-150 {
  --tw-scale-x: 1.5;
  --tw-scale-y: 1.5;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.cursor-auto {
  cursor: auto;
}
.cursor-default {
  cursor: default;
}
.cursor-pointer {
  cursor: pointer;
}
.cursor-zoom-in {
  cursor: zoom-in;
}
.cursor-zoom-out {
  cursor: zoom-out;
}
.resize {
  resize: both;
}
.list-outside {
  list-style-position: outside;
}
.list-disc {
  list-style-type: disc;
}
.list-none {
  list-style-type: none;
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.flex-row {
  flex-direction: row;
}
.flex-row-reverse {
  flex-direction: row-reverse;
}
.\\!flex-col {
  flex-direction: column !important;
}
.flex-col {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.place-content-center {
  place-content: center;
}
.place-content-between {
  place-content: space-between;
}
.content-center {
  align-content: center;
}
.items-start {
  align-items: flex-start;
}
.items-center {
  align-items: center;
}
.items-stretch {
  align-items: stretch;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.justify-around {
  justify-content: space-around;
}
.gap-0 {
  gap: 0px;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-x-4 {
  -moz-column-gap: 1rem;
       column-gap: 1rem;
}
.gap-y-2 {
  row-gap: 0.5rem;
}
.gap-y-5 {
  row-gap: 1.25rem;
}
.gap-y-\\[31px\\] {
  row-gap: 31px;
}
.place-self-center {
  place-self: center;
}
.self-auto {
  align-self: auto;
}
.self-end {
  align-self: flex-end;
}
.self-center {
  align-self: center;
}
.overflow-auto {
  overflow: auto;
}
.\\!overflow-hidden {
  overflow: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-visible {
  overflow: visible;
}
.overflow-scroll {
  overflow: scroll;
}
.overflow-x-auto {
  overflow-x: auto;
}
.overflow-y-auto {
  overflow-y: auto;
}
.overflow-x-hidden {
  overflow-x: hidden;
}
.\\!overflow-x-visible {
  overflow-x: visible !important;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.text-ellipsis {
  text-overflow: ellipsis;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.whitespace-pre-wrap {
  white-space: pre-wrap;
}
.break-words {
  overflow-wrap: break-word;
}
.break-all {
  word-break: break-all;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-2xl {
  border-radius: 1rem;
}
.rounded-3xl {
  border-radius: 1.5rem;
}
.rounded-\\[12px\\] {
  border-radius: 12px;
}
.rounded-\\[16px\\] {
  border-radius: 16px;
}
.rounded-\\[18px\\] {
  border-radius: 18px;
}
.rounded-\\[8px\\] {
  border-radius: 8px;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.rounded-b-2xl {
  border-bottom-right-radius: 1rem;
  border-bottom-left-radius: 1rem;
}
.rounded-l-lg {
  border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
.rounded-r-lg {
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}
.rounded-t-2xl {
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
}
.rounded-t-\\[16px\\] {
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
}
.border {
  border-width: 1px;
}
.border-0 {
  border-width: 0px;
}
.border-2 {
  border-width: 2px;
}
.border-\\[1px\\] {
  border-width: 1px;
}
.border-\\[8px\\] {
  border-width: 8px;
}
.border-y-2 {
  border-top-width: 2px;
  border-bottom-width: 2px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-b-\\[1px\\] {
  border-bottom-width: 1px;
}
.border-l {
  border-left-width: 1px;
}
.border-r {
  border-right-width: 1px;
}
.border-t {
  border-top-width: 1px;
}
.border-solid {
  border-style: solid;
}
.border-dashed {
  border-style: dashed;
}
.border-none {
  border-style: none;
}
.\\!border-neutral-notebook {
  --tw-border-opacity: 1 !important;
  border-color: rgb(220 227 239 / var(--tw-border-opacity)) !important;
}
.border-\\[\\#CFD7E5\\] {
  --tw-border-opacity: 1;
  border-color: rgb(207 215 229 / var(--tw-border-opacity));
}
.border-black {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
}
.border-neutral-chalk {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}
.border-neutral-notebook {
  --tw-border-opacity: 1;
  border-color: rgb(220 227 239 / var(--tw-border-opacity));
}
.border-neutral-periwinkle {
  --tw-border-opacity: 1;
  border-color: rgb(207 215 229 / var(--tw-border-opacity));
}
.border-primary-apricot {
  --tw-border-opacity: 1;
  border-color: rgb(247 148 30 / var(--tw-border-opacity));
}
.border-primary-navyblue-bright {
  --tw-border-opacity: 1;
  border-color: rgb(102 96 185 / var(--tw-border-opacity));
}
.border-white {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}
.border-t-neutral-eraser {
  --tw-border-opacity: 1;
  border-top-color: rgb(180 180 180 / var(--tw-border-opacity));
}
.\\!bg-alert-error {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(247 119 103 / var(--tw-bg-opacity)) !important;
}
.\\!bg-neutral-chalk {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity)) !important;
}
.\\!bg-neutral-notebook {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(220 227 239 / var(--tw-bg-opacity)) !important;
}
.\\!bg-primary-navyblue-shade {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(62 58 110 / var(--tw-bg-opacity)) !important;
}
.\\!bg-white {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity)) !important;
}
.bg-\\[\\#000000\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}
.bg-\\[\\#0755AE\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(7 85 174 / var(--tw-bg-opacity));
}
.bg-\\[\\#16133E\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(22 19 62 / var(--tw-bg-opacity));
}
.bg-\\[\\#16143e\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(22 20 62 / var(--tw-bg-opacity));
}
.bg-\\[\\#3F3A94\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(63 58 148 / var(--tw-bg-opacity));
}
.bg-\\[\\#6EBFE6\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(110 191 230 / var(--tw-bg-opacity));
}
.bg-\\[\\#8099BB\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(128 153 187 / var(--tw-bg-opacity));
}
.bg-\\[\\#85AEB7\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(133 174 183 / var(--tw-bg-opacity));
}
.bg-\\[\\#9B9B9B\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(155 155 155 / var(--tw-bg-opacity));
}
.bg-\\[\\#CB7F32\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(203 127 50 / var(--tw-bg-opacity));
}
.bg-\\[\\#CFAE00\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(207 174 0 / var(--tw-bg-opacity));
}
.bg-\\[\\#D4F2FF\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(212 242 255 / var(--tw-bg-opacity));
}
.bg-\\[\\#E03636\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(224 54 54 / var(--tw-bg-opacity));
}
.bg-\\[\\#FFFFFF33\\] {
  background-color: #FFFFFF33;
}
.bg-\\[\\#f5f7fc\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(245 247 252 / var(--tw-bg-opacity));
}
.bg-alert-error {
  --tw-bg-opacity: 1;
  background-color: rgb(247 119 103 / var(--tw-bg-opacity));
}
.bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}
.bg-gray-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity));
}
.bg-neutral-chalk {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-neutral-chalk\\/\\[0\\.92\\] {
  background-color: rgb(255 255 255 / 0.92);
}
.bg-neutral-dust {
  --tw-bg-opacity: 1;
  background-color: rgb(160 160 160 / var(--tw-bg-opacity));
}
.bg-neutral-eraser {
  --tw-bg-opacity: 1;
  background-color: rgb(180 180 180 / var(--tw-bg-opacity));
}
.bg-neutral-graphite {
  --tw-bg-opacity: 1;
  background-color: rgb(130 126 126 / var(--tw-bg-opacity));
}
.bg-neutral-marker {
  --tw-bg-opacity: 1;
  background-color: rgb(51 51 51 / var(--tw-bg-opacity));
}
.bg-neutral-notebook\\/50 {
  background-color: rgb(220 227 239 / 0.5);
}
.bg-neutral-periwinkle {
  --tw-bg-opacity: 1;
  background-color: rgb(207 215 229 / var(--tw-bg-opacity));
}
.bg-neutral-sketchbook {
  --tw-bg-opacity: 1;
  background-color: rgb(244 247 252 / var(--tw-bg-opacity));
}
.bg-neutral-whiteboard {
  --tw-bg-opacity: 1;
  background-color: rgb(250 251 253 / var(--tw-bg-opacity));
}
.bg-primary-apricot {
  --tw-bg-opacity: 1;
  background-color: rgb(247 148 30 / var(--tw-bg-opacity));
}
.bg-primary-apricot-light {
  --tw-bg-opacity: 1;
  background-color: rgb(255 226 191 / var(--tw-bg-opacity));
}
.bg-primary-azure {
  --tw-bg-opacity: 1;
  background-color: rgb(29 130 247 / var(--tw-bg-opacity));
}
.bg-primary-black {
  --tw-bg-opacity: 1;
  background-color: rgb(35 31 32 / var(--tw-bg-opacity));
}
.bg-primary-navyblue {
  --tw-bg-opacity: 1;
  background-color: rgb(38 34 98 / var(--tw-bg-opacity));
}
.bg-primary-navyblue-bright {
  --tw-bg-opacity: 1;
  background-color: rgb(102 96 185 / var(--tw-bg-opacity));
}
.bg-primary-navyblue-bright\\/\\[0\\.65\\] {
  background-color: rgb(102 96 185 / 0.65);
}
.bg-primary-navyblue-dark {
  --tw-bg-opacity: 1;
  background-color: rgb(22 19 62 / var(--tw-bg-opacity));
}
.bg-primary-navyblue-dim {
  --tw-bg-opacity: 1;
  background-color: rgb(40 41 98 / var(--tw-bg-opacity));
}
.bg-primary-navyblue-shade {
  --tw-bg-opacity: 1;
  background-color: rgb(62 58 110 / var(--tw-bg-opacity));
}
.bg-primary-navyblue-shade\\/\\[0\\.65\\] {
  background-color: rgb(62 58 110 / 0.65);
}
.bg-primary-skyblue {
  --tw-bg-opacity: 1;
  background-color: rgb(39 170 225 / var(--tw-bg-opacity));
}
.bg-primary-skyblue-faded {
  --tw-bg-opacity: 1;
  background-color: rgb(232 248 255 / var(--tw-bg-opacity));
}
.bg-primary-skyblue-light {
  --tw-bg-opacity: 1;
  background-color: rgb(200 235 250 / var(--tw-bg-opacity));
}
.bg-success-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(21 128 61 / var(--tw-bg-opacity));
}
.bg-transparent {
  background-color: transparent;
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-\\[url\\(\\"\\/public\\/img\\/Background_Default_1\\.svg\\"\\)\\] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.bg-\\[url\\(\\'\\/public\\/img\\/Background_Special\\.svg\\'\\)\\] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.bg-\\[url\\(\\'\\/public\\/img\\/badges\\/astronaut\\.svg\\'\\)\\] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.bg-\\[url\\(\\'\\/public\\/img\\/badges\\/background\\.svg\\'\\)\\] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.bg-\\[url\\(\\'\\/public\\/img\\/badges\\/more_badges\\.svg\\'\\)\\] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.bg-\\[url\\(\\'\\/public\\/img\\/exam-result\\/banner\\.svg\\'\\)\\] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
.bg-\\[url\\(\\'\\/public\\/img\\/exam-result\\/boy-figure\\.svg\\'\\)\\] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.bg-\\[url\\(\\'\\/public\\/img\\/exam-result\\/bubble\\.svg\\'\\)\\] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
.bg-\\[url\\(\\'\\/public\\/img\\/exam-result\\/jc-banner\\.svg\\'\\)\\] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}
.bg-\\[url\\(\\'\\/src\\/assets\\/background\\/Background_Default_1\\.svg\\'\\)\\] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}
.bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.bg-none {
  background-image: none;
}
.from-\\[\\#018BC4\\] {
  --tw-gradient-from: #018BC4 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(1 139 196 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#3F39A2\\] {
  --tw-gradient-from: #3F39A2 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(63 57 162 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-neutral-chalk {
  --tw-gradient-from: #FFFFFF var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-neutral-sketchbook {
  --tw-gradient-from: #F4F7FC var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(244 247 252 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.to-\\[\\#19A2C0\\] {
  --tw-gradient-to: #19A2C0 var(--tw-gradient-to-position);
}
.to-\\[\\#8F4690\\] {
  --tw-gradient-to: #8F4690 var(--tw-gradient-to-position);
}
.bg-contain {
  background-size: contain;
}
.bg-cover {
  background-size: cover;
}
.bg-fixed {
  background-attachment: fixed;
}
.bg-clip-text {
  -webkit-background-clip: text;
          background-clip: text;
}
.bg-\\[-10px\\] {
  background-position: -10px;
}
.bg-\\[45\\%_75\\%\\] {
  background-position: 45% 75%;
}
.bg-center {
  background-position: center;
}
.bg-left-bottom {
  background-position: left bottom;
}
.bg-no-repeat {
  background-repeat: no-repeat;
}
.fill-\\[\\#D4F2FF\\] {
  fill: #D4F2FF;
}
.fill-current {
  fill: currentColor;
}
.fill-primary-apricot {
  fill: #F7941E;
}
.stroke-neutral-chalk {
  stroke: #FFFFFF;
}
.stroke-\\[20\\] {
  stroke-width: 20;
}
.object-contain {
  -o-object-fit: contain;
     object-fit: contain;
}
.object-none {
  -o-object-fit: none;
     object-fit: none;
}
.object-left-bottom {
  -o-object-position: left bottom;
     object-position: left bottom;
}
.\\!p-8 {
  padding: 2rem !important;
}
.p-0 {
  padding: 0px;
}
.p-1 {
  padding: 0.25rem;
}
.p-1\\.5 {
  padding: 0.375rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-4 {
  padding: 1rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-8 {
  padding: 2rem;
}
.p-\\[8px\\] {
  padding: 8px;
}
.\\!px-0 {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.\\!px-2 {
  padding-left: 0.5rem !important;
  padding-right: 0.5rem !important;
}
.\\!px-4 {
  padding-left: 1rem !important;
  padding-right: 1rem !important;
}
.\\!px-6 {
  padding-left: 1.5rem !important;
  padding-right: 1.5rem !important;
}
.\\!px-8 {
  padding-left: 2rem !important;
  padding-right: 2rem !important;
}
.\\!px-\\[24px\\] {
  padding-left: 24px !important;
  padding-right: 24px !important;
}
.\\!py-0 {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}
.\\!py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}
.\\!py-6 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}
.\\!py-\\[12px\\] {
  padding-top: 12px !important;
  padding-bottom: 12px !important;
}
.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-10 {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.px-12 {
  padding-left: 3rem;
  padding-right: 3rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.px-\\[16px\\] {
  padding-left: 16px;
  padding-right: 16px;
}
.px-\\[20px\\] {
  padding-left: 20px;
  padding-right: 20px;
}
.px-\\[24px\\] {
  padding-left: 24px;
  padding-right: 24px;
}
.px-\\[32px\\] {
  padding-left: 32px;
  padding-right: 32px;
}
.px-\\[38px\\] {
  padding-left: 38px;
  padding-right: 38px;
}
.px-\\[42px\\] {
  padding-left: 42px;
  padding-right: 42px;
}
.py-0 {
  padding-top: 0px;
  padding-bottom: 0px;
}
.py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-3\\.5 {
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.py-\\[14px\\] {
  padding-top: 14px;
  padding-bottom: 14px;
}
.py-\\[16px\\] {
  padding-top: 16px;
  padding-bottom: 16px;
}
.py-\\[1px\\] {
  padding-top: 1px;
  padding-bottom: 1px;
}
.py-\\[24px\\] {
  padding-top: 24px;
  padding-bottom: 24px;
}
.py-\\[2px\\] {
  padding-top: 2px;
  padding-bottom: 2px;
}
.py-\\[39px\\] {
  padding-top: 39px;
  padding-bottom: 39px;
}
.\\!pb-0 {
  padding-bottom: 0px !important;
}
.\\!pb-6 {
  padding-bottom: 1.5rem !important;
}
.\\!pb-\\[75px\\] {
  padding-bottom: 75px !important;
}
.\\!pt-2 {
  padding-top: 0.5rem !important;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pb-5 {
  padding-bottom: 1.25rem;
}
.pb-6 {
  padding-bottom: 1.5rem;
}
.pb-8 {
  padding-bottom: 2rem;
}
.pb-\\[108px\\] {
  padding-bottom: 108px;
}
.pb-\\[24px\\] {
  padding-bottom: 24px;
}
.pb-\\[30px\\] {
  padding-bottom: 30px;
}
.pb-\\[8px\\] {
  padding-bottom: 8px;
}
.pl-1 {
  padding-left: 0.25rem;
}
.pl-2 {
  padding-left: 0.5rem;
}
.pl-24 {
  padding-left: 6rem;
}
.pl-4 {
  padding-left: 1rem;
}
.pl-8 {
  padding-left: 2rem;
}
.pl-\\[140px\\] {
  padding-left: 140px;
}
.pl-\\[158px\\] {
  padding-left: 158px;
}
.pl-\\[15px\\] {
  padding-left: 15px;
}
.pl-\\[2px\\] {
  padding-left: 2px;
}
.pr-1 {
  padding-right: 0.25rem;
}
.pr-2 {
  padding-right: 0.5rem;
}
.pr-24 {
  padding-right: 6rem;
}
.pr-4 {
  padding-right: 1rem;
}
.pr-5 {
  padding-right: 1.25rem;
}
.pr-6 {
  padding-right: 1.5rem;
}
.pr-8 {
  padding-right: 2rem;
}
.pt-0 {
  padding-top: 0px;
}
.pt-0\\.5 {
  padding-top: 0.125rem;
}
.pt-1 {
  padding-top: 0.25rem;
}
.pt-10 {
  padding-top: 2.5rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-3 {
  padding-top: 0.75rem;
}
.pt-4 {
  padding-top: 1rem;
}
.pt-6 {
  padding-top: 1.5rem;
}
.pt-\\[16px\\] {
  padding-top: 16px;
}
.pt-\\[2px\\] {
  padding-top: 2px;
}
.pt-\\[6px\\] {
  padding-top: 6px;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.align-baseline {
  vertical-align: baseline;
}
.align-top {
  vertical-align: top;
}
.align-middle {
  vertical-align: middle;
}
.align-bottom {
  vertical-align: bottom;
}
.align-text-top {
  vertical-align: text-top;
}
.align-super {
  vertical-align: super;
}
.font-\\[\\'Open_Sans\\'\\] {
  font-family: 'Open Sans';
}
.\\!text-\\[13px\\] {
  font-size: 13px !important;
}
.\\!text-sm {
  font-size: 14px !important;
}
.text-\\[1\\.125rem\\] {
  font-size: 1.125rem;
}
.text-\\[10px\\] {
  font-size: 10px;
}
.text-\\[12px\\] {
  font-size: 12px;
}
.text-\\[14px\\] {
  font-size: 14px;
}
.text-\\[16px\\] {
  font-size: 16px;
}
.text-\\[1rem\\] {
  font-size: 1rem;
}
.text-\\[20px\\] {
  font-size: 20px;
}
.text-\\[24px\\] {
  font-size: 24px;
}
.text-\\[32px\\] {
  font-size: 32px;
}
.text-\\[34px\\] {
  font-size: 34px;
}
.text-\\[48px\\] {
  font-size: 48px;
}
.text-lg {
  font-size: 20px;
}
.text-md {
  font-size: 16px;
}
.text-sm {
  font-size: 14px;
}
.text-xl {
  font-size: 24px;
}
.text-xs {
  font-size: 12px;
}
.text-xxl {
  font-size: 34px;
}
.text-xxs {
  font-size: 10px;
}
.\\!font-black {
  font-weight: 900 !important;
}
.\\!font-bold {
  font-weight: 700 !important;
}
.\\!font-extrabold {
  font-weight: 800 !important;
}
.font-black {
  font-weight: 900;
}
.font-bold {
  font-weight: 700;
}
.font-extrabold {
  font-weight: 800;
}
.font-light {
  font-weight: 300;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.font-thin {
  font-weight: 100;
}
.uppercase {
  text-transform: uppercase;
}
.capitalize {
  text-transform: capitalize;
}
.\\!leading-3 {
  line-height: .75rem !important;
}
.\\!leading-5 {
  line-height: 1.25rem !important;
}
.\\!leading-\\[1\\.2\\] {
  line-height: 1.2 !important;
}
.leading-10 {
  line-height: 2.5rem;
}
.leading-3 {
  line-height: .75rem;
}
.leading-3\\.5 {
  line-height: 14px;
}
.leading-4 {
  line-height: 1rem;
}
.leading-5 {
  line-height: 1.25rem;
}
.leading-6 {
  line-height: 1.5rem;
}
.leading-7 {
  line-height: 1.75rem;
}
.leading-8 {
  line-height: 2rem;
}
.leading-\\[1\\.2\\] {
  line-height: 1.2;
}
.leading-\\[1\\.5\\] {
  line-height: 1.5;
}
.leading-\\[10px\\] {
  line-height: 10px;
}
.leading-\\[14px\\] {
  line-height: 14px;
}
.leading-\\[16px\\] {
  line-height: 16px;
}
.leading-\\[19px\\] {
  line-height: 19px;
}
.leading-\\[21px\\] {
  line-height: 21px;
}
.leading-\\[24px\\] {
  line-height: 24px;
}
.leading-\\[26px\\] {
  line-height: 26px;
}
.leading-\\[27px\\] {
  line-height: 27px;
}
.leading-\\[32px\\] {
  line-height: 32px;
}
.leading-\\[34px\\] {
  line-height: 34px;
}
.leading-\\[35px\\] {
  line-height: 35px;
}
.leading-\\[46px\\] {
  line-height: 46px;
}
.leading-\\[54px\\] {
  line-height: 54px;
}
.leading-normal {
  line-height: 1.5;
}
.leading-snug {
  line-height: 1.375;
}
.\\!text-alert-error {
  --tw-text-opacity: 1 !important;
  color: rgb(247 119 103 / var(--tw-text-opacity)) !important;
}
.\\!text-neutral-chalk {
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity)) !important;
}
.\\!text-neutral-pencil {
  --tw-text-opacity: 1 !important;
  color: rgb(81 81 81 / var(--tw-text-opacity)) !important;
}
.\\!text-primary-apricot {
  --tw-text-opacity: 1 !important;
  color: rgb(247 148 30 / var(--tw-text-opacity)) !important;
}
.\\!text-primary-neptune-dark {
  --tw-text-opacity: 1 !important;
  color: rgb(48 80 141 / var(--tw-text-opacity)) !important;
}
.\\!text-primary-skyblue {
  --tw-text-opacity: 1 !important;
  color: rgb(39 170 225 / var(--tw-text-opacity)) !important;
}
.text-\\[\\#262262\\] {
  --tw-text-opacity: 1;
  color: rgb(38 34 98 / var(--tw-text-opacity));
}
.text-\\[\\#476DB3\\] {
  --tw-text-opacity: 1;
  color: rgb(71 109 179 / var(--tw-text-opacity));
}
.text-\\[\\#72CC7C\\] {
  --tw-text-opacity: 1;
  color: rgb(114 204 124 / var(--tw-text-opacity));
}
.text-\\[\\#A0E274\\] {
  --tw-text-opacity: 1;
  color: rgb(160 226 116 / var(--tw-text-opacity));
}
.text-\\[\\#B4B4B4\\] {
  --tw-text-opacity: 1;
  color: rgb(180 180 180 / var(--tw-text-opacity));
}
.text-\\[\\#C3CAD6\\] {
  --tw-text-opacity: 1;
  color: rgb(195 202 214 / var(--tw-text-opacity));
}
.text-\\[\\#EF4A46\\] {
  --tw-text-opacity: 1;
  color: rgb(239 74 70 / var(--tw-text-opacity));
}
.text-\\[\\#F56468\\] {
  --tw-text-opacity: 1;
  color: rgb(245 100 104 / var(--tw-text-opacity));
}
.text-\\[\\#F6C483\\] {
  --tw-text-opacity: 1;
  color: rgb(246 196 131 / var(--tw-text-opacity));
}
.text-\\[\\#FED00B\\] {
  --tw-text-opacity: 1;
  color: rgb(254 208 11 / var(--tw-text-opacity));
}
.text-alert-error {
  --tw-text-opacity: 1;
  color: rgb(247 119 103 / var(--tw-text-opacity));
}
.text-alert-success {
  --tw-text-opacity: 1;
  color: rgb(72 160 116 / var(--tw-text-opacity));
}
.text-alert-warning {
  --tw-text-opacity: 1;
  color: rgb(254 208 11 / var(--tw-text-opacity));
}
.text-error-500 {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity));
}
.text-neutral-chalk {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.text-neutral-dust {
  --tw-text-opacity: 1;
  color: rgb(160 160 160 / var(--tw-text-opacity));
}
.text-neutral-eraser {
  --tw-text-opacity: 1;
  color: rgb(180 180 180 / var(--tw-text-opacity));
}
.text-neutral-graphite {
  --tw-text-opacity: 1;
  color: rgb(130 126 126 / var(--tw-text-opacity));
}
.text-neutral-marker {
  --tw-text-opacity: 1;
  color: rgb(51 51 51 / var(--tw-text-opacity));
}
.text-neutral-pencil {
  --tw-text-opacity: 1;
  color: rgb(81 81 81 / var(--tw-text-opacity));
}
.text-neutral-periwinkle {
  --tw-text-opacity: 1;
  color: rgb(207 215 229 / var(--tw-text-opacity));
}
.text-neutral-whiteboard {
  --tw-text-opacity: 1;
  color: rgb(250 251 253 / var(--tw-text-opacity));
}
.text-neutral-whiteboard\\/50 {
  color: rgb(250 251 253 / 0.5);
}
.text-primary-apricot {
  --tw-text-opacity: 1;
  color: rgb(247 148 30 / var(--tw-text-opacity));
}
.text-primary-apricot-dark {
  --tw-text-opacity: 1;
  color: rgb(229 123 65 / var(--tw-text-opacity));
}
.text-primary-navyblue {
  --tw-text-opacity: 1;
  color: rgb(38 34 98 / var(--tw-text-opacity));
}
.text-primary-navyblue-bright {
  --tw-text-opacity: 1;
  color: rgb(102 96 185 / var(--tw-text-opacity));
}
.text-primary-navyblue-dark {
  --tw-text-opacity: 1;
  color: rgb(22 19 62 / var(--tw-text-opacity));
}
.text-primary-navyblue-dim {
  --tw-text-opacity: 1;
  color: rgb(40 41 98 / var(--tw-text-opacity));
}
.text-primary-navyblue-faded {
  --tw-text-opacity: 1;
  color: rgb(206 205 242 / var(--tw-text-opacity));
}
.text-primary-navyblue-shade {
  --tw-text-opacity: 1;
  color: rgb(62 58 110 / var(--tw-text-opacity));
}
.text-primary-skyblue {
  --tw-text-opacity: 1;
  color: rgb(39 170 225 / var(--tw-text-opacity));
}
.text-primary-skyblue-faded {
  --tw-text-opacity: 1;
  color: rgb(232 248 255 / var(--tw-text-opacity));
}
.text-transparent {
  color: transparent;
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.underline {
  text-decoration-line: underline;
}
.decoration-dashed {
  text-decoration-style: dashed;
}
.opacity-0 {
  opacity: 0;
}
.opacity-20 {
  opacity: 0.2;
}
.opacity-50 {
  opacity: 0.5;
}
.shadow-\\[0_3px_15px_0_\\#27AAE166\\] {
  --tw-shadow: 0 3px 15px 0 #27AAE166;
  --tw-shadow-colored: 0 3px 15px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_0px_24px_0px_rgba\\(255\\2c 255\\2c 255\\2c 0\\.20\\)\\] {
  --tw-shadow: 0px 0px 24px 0px rgba(255,255,255,0.20);
  --tw-shadow-colored: 0px 0px 24px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_12px_0px_0px_\\#2CA2DB\\] {
  --tw-shadow: 0px 12px 0px 0px #2CA2DB;
  --tw-shadow-colored: 0px 12px 0px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_8px_0px_0px_\\#282661\\] {
  --tw-shadow: 0px 8px 0px 0px #282661;
  --tw-shadow-colored: 0px 8px 0px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[4px_-4px_0_0_\\#CFD7E5_inset\\] {
  --tw-shadow: 4px -4px 0 0 #CFD7E5 inset;
  --tw-shadow-colored: inset 4px -4px 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline {
  outline-style: solid;
}
.ring-2 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-primary-apricot {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(247 148 30 / var(--tw-ring-opacity));
}
.ring-opacity-50 {
  --tw-ring-opacity: 0.5;
}
.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.\\!backdrop-blur-0 {
  --tw-backdrop-blur: blur(0) !important;
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia) !important;
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia) !important;
}
.backdrop-blur-sm {
  --tw-backdrop-blur: blur(4px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

::-webkit-scrollbar {
  width: 4px;
}
::-webkit-scrollbar-track {
  color: transparent;
  width: 4px;
}

::-webkit-scrollbar-thumb {
  background: #FFFFFF4d;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #E5E7EB;
  border-radius: 4px;
}

body {
  margin: 0;
  font-family: 'Twemoji Country Flags', 'source-han-sans-simplified-c',
    sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body::-webkit-scrollbar {
  display: none;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

#root {
  overflow: auto;
  max-height: 100%;
  min-height: 100%;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}

#root::-webkit-scrollbar {
  display: none;
}

.no-scrollbar::-webkit-scrollbar {
  display: none;
}

.date-picker input {
  -webkit-appearance: none;
  width: 100%
}

.date-picker input::-webkit-date-and-time-value {
  text-align: left;
}

.break-words {
  word-break: break-word;
}

.marker\\:text-primary-apricot *::marker {
  color: rgb(247 148 30 );
}

.marker\\:text-primary-apricot::marker {
  color: rgb(247 148 30 );
}

.before\\:fixed::before {
  content: var(--tw-content);
  position: fixed;
}

.before\\:left-0::before {
  content: var(--tw-content);
  left: 0px;
}

.before\\:top-16::before {
  content: var(--tw-content);
  top: 4rem;
}

.before\\:-z-10::before {
  content: var(--tw-content);
  z-index: -10;
}

.before\\:h-\\[calc\\(100\\%\\+76px\\)\\]::before {
  content: var(--tw-content);
  height: calc(100% + 76px);
}

.before\\:w-screen::before {
  content: var(--tw-content);
  width: 100vw;
}

.before\\:bg-primary-navyblue-dark::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(22 19 62 / var(--tw-bg-opacity));
}

.before\\:bg-\\[url\\(\\'\\/public\\/img\\/Background_Default_1\\.svg\\'\\)\\]::before {
  content: var(--tw-content);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.before\\:bg-cover::before {
  content: var(--tw-content);
  background-size: cover;
}

.before\\:bg-fixed::before {
  content: var(--tw-content);
  background-attachment: fixed;
}

.before\\:bg-\\[6\\.5\\%_41\\%\\]::before {
  content: var(--tw-content);
  background-position: 6.5% 41%;
}

.before\\:bg-no-repeat::before {
  content: var(--tw-content);
  background-repeat: no-repeat;
}

.last\\:\\!col-span-2:last-child {
  grid-column: span 2 / span 2 !important;
}

.last\\:mb-0:last-child {
  margin-bottom: 0px;
}

.last\\:mr-0:last-child {
  margin-right: 0px;
}

.last\\:pb-0:last-child {
  padding-bottom: 0px;
}

.first-of-type\\:mt-2:first-of-type {
  margin-top: 0.5rem;
}

.last-of-type\\:mb-0:last-of-type {
  margin-bottom: 0px;
}

.last-of-type\\:\\!pb-0:last-of-type {
  padding-bottom: 0px !important;
}

.focus-within\\:text-primary-apricot:focus-within {
  --tw-text-opacity: 1;
  color: rgb(247 148 30 / var(--tw-text-opacity));
}

.hover\\:\\!scale-100:hover {
  --tw-scale-x: 1 !important;
  --tw-scale-y: 1 !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.hover\\:\\!scale-\\[1\\.01\\]:hover {
  --tw-scale-x: 1.01 !important;
  --tw-scale-y: 1.01 !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.hover\\:transform:hover {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:cursor-pointer:hover {
  cursor: pointer;
}

.hover\\:rounded-\\[8px\\]:hover {
  border-radius: 8px;
}

.hover\\:bg-\\[\\#FFFFFF33\\]:hover {
  background-color: #FFFFFF33;
}

.hover\\:bg-primary-navyblue-bright:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(102 96 185 / var(--tw-bg-opacity));
}

.hover\\:bg-primary-navyblue-shade\\/\\[0\\.65\\]:hover {
  background-color: rgb(62 58 110 / 0.65);
}

.hover\\:bg-primary-skyblue-light:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(200 235 250 / var(--tw-bg-opacity));
}

.hover\\:text-alert-error:hover {
  --tw-text-opacity: 1;
  color: rgb(247 119 103 / var(--tw-text-opacity));
}

.hover\\:text-primary-skyblue:hover {
  --tw-text-opacity: 1;
  color: rgb(39 170 225 / var(--tw-text-opacity));
}

.focus-visible\\:outline-primary-apricot:focus-visible {
  outline-color: #F7941E;
}

.active\\:bg-primary-skyblue:active {
  --tw-bg-opacity: 1;
  background-color: rgb(39 170 225 / var(--tw-bg-opacity));
}

@media not all and (min-width: 1280px) {

  .max-xl\\:hidden {
    display: none;
  }

  .max-xl\\:\\!px-5 {
    padding-left: 1.25rem !important;
    padding-right: 1.25rem !important;
  }
}

@media not all and (min-width: 1024px) {

  .max-lg\\:relative {
    position: relative;
  }

  .max-lg\\:-left-10 {
    left: -2.5rem;
  }

  .max-lg\\:bottom-12 {
    bottom: 3rem;
  }

  .max-lg\\:bottom-\\[-35rem\\] {
    bottom: -35rem;
  }

  .max-lg\\:bottom-\\[50px\\] {
    bottom: 50px;
  }

  .max-lg\\:left-1\\/2 {
    left: 50%;
  }

  .max-lg\\:left-\\[-35rem\\] {
    left: -35rem;
  }

  .max-lg\\:z-0 {
    z-index: 0;
  }

  .max-lg\\:z-10 {
    z-index: 10;
  }

  .max-lg\\:mx-auto {
    margin-left: auto;
    margin-right: auto;
  }

  .max-lg\\:my-\\[24px\\] {
    margin-top: 24px;
    margin-bottom: 24px;
  }

  .max-lg\\:my-auto {
    margin-top: auto;
    margin-bottom: auto;
  }

  .max-lg\\:mb-1 {
    margin-bottom: 0.25rem;
  }

  .max-lg\\:mb-4 {
    margin-bottom: 1rem;
  }

  .max-lg\\:mb-6 {
    margin-bottom: 1.5rem;
  }

  .max-lg\\:mb-8 {
    margin-bottom: 2rem;
  }

  .max-lg\\:ml-\\[106px\\] {
    margin-left: 106px;
  }

  .max-lg\\:ml-\\[14px\\] {
    margin-left: 14px;
  }

  .max-lg\\:ml-auto {
    margin-left: auto;
  }

  .max-lg\\:mt-0 {
    margin-top: 0px;
  }

  .max-lg\\:mt-4 {
    margin-top: 1rem;
  }

  .max-lg\\:mt-6 {
    margin-top: 1.5rem;
  }

  .max-lg\\:mt-\\[32px\\] {
    margin-top: 32px;
  }

  .max-lg\\:block {
    display: block;
  }

  .max-lg\\:flex {
    display: flex;
  }

  .max-lg\\:\\!hidden {
    display: none !important;
  }

  .max-lg\\:hidden {
    display: none;
  }

  .max-lg\\:\\!h-\\[46px\\] {
    height: 46px !important;
  }

  .max-lg\\:h-\\[140px\\] {
    height: 140px;
  }

  .max-lg\\:h-\\[232px\\] {
    height: 232px;
  }

  .max-lg\\:h-\\[242px\\] {
    height: 242px;
  }

  .max-lg\\:h-\\[70px\\] {
    height: 70px;
  }

  .max-lg\\:h-\\[78px\\] {
    height: 78px;
  }

  .max-lg\\:h-\\[80px\\] {
    height: 80px;
  }

  .max-lg\\:h-\\[calc\\(100svh-124px\\)\\] {
    height: calc(100svh - 124px);
  }

  .max-lg\\:h-\\[calc\\(100svh-131px\\)\\] {
    height: calc(100svh - 131px);
  }

  .max-lg\\:h-\\[calc\\(100svh-136px\\)\\] {
    height: calc(100svh - 136px);
  }

  .max-lg\\:h-\\[calc\\(100vh-110px\\)\\] {
    height: calc(100vh - 110px);
  }

  .max-lg\\:h-fit {
    height: -moz-fit-content;
    height: fit-content;
  }

  .max-lg\\:max-h-\\[94px\\] {
    max-height: 94px;
  }

  .max-lg\\:max-h-\\[calc\\(100vh-187px\\)\\] {
    max-height: calc(100vh - 187px);
  }

  .max-lg\\:\\!w-2\\/6 {
    width: 33.333333% !important;
  }

  .max-lg\\:\\!w-full {
    width: 100% !important;
  }

  .max-lg\\:w-11\\/12 {
    width: 91.666667%;
  }

  .max-lg\\:w-\\[18px\\] {
    width: 18px;
  }

  .max-lg\\:w-\\[200px\\] {
    width: 200px;
  }

  .max-lg\\:w-\\[22px\\] {
    width: 22px;
  }

  .max-lg\\:w-\\[236px\\] {
    width: 236px;
  }

  .max-lg\\:w-\\[331px\\] {
    width: 331px;
  }

  .max-lg\\:w-\\[377px\\] {
    width: 377px;
  }

  .max-lg\\:w-\\[539px\\] {
    width: 539px;
  }

  .max-lg\\:w-\\[calc\\(100\\%\\*347\\/744\\)\\] {
    width: calc(100% * 347 / 744);
  }

  .max-lg\\:w-full {
    width: 100%;
  }

  .max-lg\\:\\!max-w-full {
    max-width: 100% !important;
  }

  .max-lg\\:max-w-\\[350px\\] {
    max-width: 350px;
  }

  .max-lg\\:max-w-\\[371px\\] {
    max-width: 371px;
  }

  .max-lg\\:max-w-\\[456px\\] {
    max-width: 456px;
  }

  .max-lg\\:max-w-\\[619px\\] {
    max-width: 619px;
  }

  .max-lg\\:max-w-\\[calc\\(100vw-56px-86px\\)\\] {
    max-width: calc(100vw - 56px - 86px);
  }

  .max-lg\\:max-w-\\[none\\] {
    max-width: none;
  }

  .max-lg\\:max-w-full {
    max-width: 100%;
  }

  .max-lg\\:-translate-x-1\\/2 {
    --tw-translate-x: -50%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .max-lg\\:flex-row {
    flex-direction: row;
  }

  .max-lg\\:flex-col {
    flex-direction: column;
  }

  .max-lg\\:items-start {
    align-items: flex-start;
  }

  .max-lg\\:justify-center {
    justify-content: center;
  }

  .max-lg\\:gap-4 {
    gap: 1rem;
  }

  .max-lg\\:self-end {
    align-self: flex-end;
  }

  .max-lg\\:bg-\\[center_top_5rem\\] {
    background-position: center top 5rem;
  }

  .max-lg\\:p-3 {
    padding: 0.75rem;
  }

  .max-lg\\:\\!px-4 {
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }

  .max-lg\\:px-16 {
    padding-left: 4rem;
    padding-right: 4rem;
  }

  .max-lg\\:px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .max-lg\\:py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .max-lg\\:py-\\[40px\\] {
    padding-top: 40px;
    padding-bottom: 40px;
  }

  .max-lg\\:pb-24 {
    padding-bottom: 6rem;
  }

  .max-lg\\:pb-4 {
    padding-bottom: 1rem;
  }

  .max-lg\\:pb-5 {
    padding-bottom: 1.25rem;
  }

  .max-lg\\:pb-6 {
    padding-bottom: 1.5rem;
  }

  .max-lg\\:pb-\\[56px\\] {
    padding-bottom: 56px;
  }

  .max-lg\\:pl-6 {
    padding-left: 1.5rem;
  }

  .max-lg\\:pl-\\[110px\\] {
    padding-left: 110px;
  }

  .max-lg\\:pl-\\[23px\\] {
    padding-left: 23px;
  }

  .max-lg\\:pr-6 {
    padding-right: 1.5rem;
  }

  .max-lg\\:pr-\\[110px\\] {
    padding-right: 110px;
  }

  .max-lg\\:pt-2 {
    padding-top: 0.5rem;
  }

  .max-lg\\:pt-6 {
    padding-top: 1.5rem;
  }

  .max-lg\\:\\!text-sm {
    font-size: 14px !important;
  }

  .max-lg\\:text-lg {
    font-size: 20px;
  }

  .max-lg\\:text-md {
    font-size: 16px;
  }

  .max-lg\\:text-sm {
    font-size: 14px;
  }

  .max-lg\\:text-xs {
    font-size: 12px;
  }

  .max-lg\\:font-semibold {
    font-weight: 600;
  }

  .max-lg\\:\\!leading-4 {
    line-height: 1rem !important;
  }

  .max-lg\\:\\!leading-\\[19px\\] {
    line-height: 19px !important;
  }

  .max-lg\\:leading-4 {
    line-height: 1rem;
  }

  .max-lg\\:text-neutral-whiteboard {
    --tw-text-opacity: 1;
    color: rgb(250 251 253 / var(--tw-text-opacity));
  }

  .before\\:max-lg\\:top-12::before {
    content: var(--tw-content);
    top: 3rem;
  }

  .max-lg\\:hover\\:\\!scale-\\[1\\.01\\]:hover {
    --tw-scale-x: 1.01 !important;
    --tw-scale-y: 1.01 !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
  }
}

@media not all and (min-width: 743px) {

  .max-md\\:absolute {
    position: absolute;
  }

  .max-md\\:relative {
    position: relative;
  }

  .max-md\\:-left-6 {
    left: -1.5rem;
  }

  .max-md\\:bottom-\\[70px\\] {
    bottom: 70px;
  }

  .max-md\\:left-1\\/2 {
    left: 50%;
  }

  .max-md\\:right-0 {
    right: 0px;
  }

  .max-md\\:top-1\\/2 {
    top: 50%;
  }

  .max-md\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .max-md\\:float-left {
    float: left;
  }

  .max-md\\:mx-auto {
    margin-left: auto;
    margin-right: auto;
  }

  .max-md\\:\\!mb-0 {
    margin-bottom: 0px !important;
  }

  .max-md\\:-ml-2 {
    margin-left: -0.5rem;
  }

  .max-md\\:mb-1 {
    margin-bottom: 0.25rem;
  }

  .max-md\\:mb-1\\.5 {
    margin-bottom: 0.375rem;
  }

  .max-md\\:mb-2 {
    margin-bottom: 0.5rem;
  }

  .max-md\\:mr-2 {
    margin-right: 0.5rem;
  }

  .max-md\\:mt-0 {
    margin-top: 0px;
  }

  .max-md\\:mt-1 {
    margin-top: 0.25rem;
  }

  .max-md\\:block {
    display: block;
  }

  .max-md\\:inline-block {
    display: inline-block;
  }

  .max-md\\:flex {
    display: flex;
  }

  .max-md\\:inline-flex {
    display: inline-flex;
  }

  .max-md\\:hidden {
    display: none;
  }

  .max-md\\:\\!h-4 {
    height: 1rem !important;
  }

  .max-md\\:\\!h-8 {
    height: 2rem !important;
  }

  .max-md\\:\\!h-\\[34px\\] {
    height: 34px !important;
  }

  .max-md\\:h-10 {
    height: 2.5rem;
  }

  .max-md\\:h-6 {
    height: 1.5rem;
  }

  .max-md\\:h-\\[520px\\] {
    height: 520px;
  }

  .max-md\\:h-\\[60px\\] {
    height: 60px;
  }

  .max-md\\:h-\\[90vh\\] {
    height: 90vh;
  }

  .max-md\\:h-\\[calc\\(100svh-109px\\)\\] {
    height: calc(100svh - 109px);
  }

  .max-md\\:h-\\[calc\\(100svh-116px\\)\\] {
    height: calc(100svh - 116px);
  }

  .max-md\\:h-\\[calc\\(100svh-92px\\)\\] {
    height: calc(100svh - 92px);
  }

  .max-md\\:h-\\[calc\\(100vh-100px\\)\\] {
    height: calc(100vh - 100px);
  }

  .max-md\\:h-full {
    height: 100%;
  }

  .max-md\\:max-h-\\[calc\\(100\\%-48px\\)\\] {
    max-height: calc(100% - 48px);
  }

  .max-md\\:\\!w-\\[17\\.5px\\] {
    width: 17.5px !important;
  }

  .max-md\\:\\!w-full {
    width: 100% !important;
  }

  .max-md\\:w-16 {
    width: 4rem;
  }

  .max-md\\:w-\\[175px\\] {
    width: 175px;
  }

  .max-md\\:w-\\[264px\\] {
    width: 264px;
  }

  .max-md\\:w-\\[326px\\] {
    width: 326px;
  }

  .max-md\\:w-\\[32px\\] {
    width: 32px;
  }

  .max-md\\:w-\\[calc\\(100\\%\\*266\\/375\\)\\] {
    width: calc(100% * 266 / 375);
  }

  .max-md\\:w-full {
    width: 100%;
  }

  .max-md\\:w-screen {
    width: 100vw;
  }

  .max-md\\:\\!max-w-full {
    max-width: 100% !important;
  }

  .max-md\\:max-w-full {
    max-width: 100%;
  }

  .max-md\\:-translate-x-1\\/2 {
    --tw-translate-x: -50%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .max-md\\:-translate-y-1\\/2 {
    --tw-translate-y: -50%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .max-md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .max-md\\:flex-col {
    flex-direction: column;
  }

  .max-md\\:items-start {
    align-items: flex-start;
  }

  .max-md\\:items-center {
    align-items: center;
  }

  .max-md\\:justify-center {
    justify-content: center;
  }

  .max-md\\:bg-primary-navyblue {
    --tw-bg-opacity: 1;
    background-color: rgb(38 34 98 / var(--tw-bg-opacity));
  }

  .max-md\\:bg-center {
    background-position: center;
  }

  .max-md\\:fill-primary-apricot {
    fill: #F7941E;
  }

  .max-md\\:\\!p-8 {
    padding: 2rem !important;
  }

  .max-md\\:p-2 {
    padding: 0.5rem;
  }

  .max-md\\:p-3 {
    padding: 0.75rem;
  }

  .max-md\\:p-4 {
    padding: 1rem;
  }

  .max-md\\:p-6 {
    padding: 1.5rem;
  }

  .max-md\\:\\!px-\\[0px\\] {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }

  .max-md\\:\\!py-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }

  .max-md\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .max-md\\:px-\\[17px\\] {
    padding-left: 17px;
    padding-right: 17px;
  }

  .max-md\\:py-5 {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .max-md\\:py-6 {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .max-md\\:\\!pl-0 {
    padding-left: 0px !important;
  }

  .max-md\\:\\!pr-4 {
    padding-right: 1rem !important;
  }

  .max-md\\:pb-2 {
    padding-bottom: 0.5rem;
  }

  .max-md\\:pb-2\\.5 {
    padding-bottom: 0.625rem;
  }

  .max-md\\:pb-4 {
    padding-bottom: 1rem;
  }

  .max-md\\:pb-\\[84px\\] {
    padding-bottom: 84px;
  }

  .max-md\\:pl-2 {
    padding-left: 0.5rem;
  }

  .max-md\\:pt-2 {
    padding-top: 0.5rem;
  }

  .max-md\\:pt-\\[16px\\] {
    padding-top: 16px;
  }

  .max-md\\:pt-\\[4px\\] {
    padding-top: 4px;
  }

  .max-md\\:\\!text-md {
    font-size: 16px !important;
  }

  .max-md\\:text-\\[12px\\] {
    font-size: 12px;
  }

  .max-md\\:text-md {
    font-size: 16px;
  }

  .max-md\\:text-xl {
    font-size: 24px;
  }

  .max-md\\:text-xs {
    font-size: 12px;
  }

  .max-md\\:leading-3 {
    line-height: .75rem;
  }

  .max-md\\:leading-6 {
    line-height: 1.5rem;
  }

  .max-md\\:leading-8 {
    line-height: 2rem;
  }

  .max-md\\:text-neutral-whiteboard {
    --tw-text-opacity: 1;
    color: rgb(250 251 253 / var(--tw-text-opacity));
  }

  .before\\:max-md\\:h-\\[calc\\(100\\%\\+68px\\)\\]::before {
    content: var(--tw-content);
    height: calc(100% + 68px);
  }
}

@media not all and (min-width: 640px) {

  .max-sm\\:bottom-\\[-40rem\\] {
    bottom: -40rem;
  }

  .max-sm\\:left-\\[-40rem\\] {
    left: -40rem;
  }

  .max-sm\\:my-\\[16px\\] {
    margin-top: 16px;
    margin-bottom: 16px;
  }

  .max-sm\\:\\!mb-1 {
    margin-bottom: 0.25rem !important;
  }

  .max-sm\\:\\!mb-4 {
    margin-bottom: 1rem !important;
  }

  .max-sm\\:\\!ml-0 {
    margin-left: 0px !important;
  }

  .max-sm\\:ml-\\[50px\\] {
    margin-left: 50px;
  }

  .max-sm\\:block {
    display: block;
  }

  .max-sm\\:hidden {
    display: none;
  }

  .max-sm\\:h-\\[101px\\] {
    height: 101px;
  }

  .max-sm\\:h-\\[133px\\] {
    height: 133px;
  }

  .max-sm\\:h-\\[170px\\] {
    height: 170px;
  }

  .max-sm\\:h-\\[183px\\] {
    height: 183px;
  }

  .max-sm\\:h-\\[44px\\] {
    height: 44px;
  }

  .max-sm\\:h-\\[84px\\] {
    height: 84px;
  }

  .max-sm\\:h-\\[calc\\(100vh-390px\\)\\] {
    height: calc(100vh - 390px);
  }

  .max-sm\\:h-\\[calc\\(100vh-450px\\)\\] {
    height: calc(100vh - 450px);
  }

  .max-sm\\:max-h-\\[250px\\] {
    max-height: 250px;
  }

  .max-sm\\:\\!w-full {
    width: 100% !important;
  }

  .max-sm\\:w-1\\/2 {
    width: 50%;
  }

  .max-sm\\:w-\\[12\\%\\] {
    width: 12%;
  }

  .max-sm\\:w-\\[134px\\] {
    width: 134px;
  }

  .max-sm\\:w-\\[15\\%\\] {
    width: 15%;
  }

  .max-sm\\:w-\\[150px\\] {
    width: 150px;
  }

  .max-sm\\:w-\\[18\\%\\] {
    width: 18%;
  }

  .max-sm\\:w-\\[180px\\] {
    width: 180px;
  }

  .max-sm\\:w-\\[20\\%\\] {
    width: 20%;
  }

  .max-sm\\:w-\\[210px\\] {
    width: 210px;
  }

  .max-sm\\:w-\\[224px\\] {
    width: 224px;
  }

  .max-sm\\:w-\\[25\\%\\] {
    width: 25%;
  }

  .max-sm\\:w-\\[296px\\] {
    width: 296px;
  }

  .max-sm\\:w-\\[5\\%\\] {
    width: 5%;
  }

  .max-sm\\:w-\\[6\\%\\] {
    width: 6%;
  }

  .max-sm\\:w-full {
    width: 100%;
  }

  .max-sm\\:\\!max-w-none {
    max-width: none !important;
  }

  .max-sm\\:max-w-\\[344px\\] {
    max-width: 344px;
  }

  .max-sm\\:max-w-full {
    max-width: 100%;
  }

  .max-sm\\:flex-col {
    flex-direction: column;
  }

  .max-sm\\:justify-center {
    justify-content: center;
  }

  .max-sm\\:gap-6 {
    gap: 1.5rem;
  }

  .max-sm\\:rounded-\\[29px\\] {
    border-radius: 29px;
  }

  .max-sm\\:bg-\\[center_top_10rem\\] {
    background-position: center top 10rem;
  }

  .max-sm\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .max-sm\\:px-\\[24px\\] {
    padding-left: 24px;
    padding-right: 24px;
  }

  .max-sm\\:\\!pl-6 {
    padding-left: 1.5rem !important;
  }

  .max-sm\\:\\!pl-7 {
    padding-left: 1.75rem !important;
  }

  .max-sm\\:pl-\\[15px\\] {
    padding-left: 15px;
  }

  .max-sm\\:pr-\\[15px\\] {
    padding-right: 15px;
  }

  .max-sm\\:text-\\[10px\\] {
    font-size: 10px;
  }

  .max-sm\\:text-\\[14px\\] {
    font-size: 14px;
  }

  .max-sm\\:text-\\[16px\\] {
    font-size: 16px;
  }

  .max-sm\\:text-\\[24px\\] {
    font-size: 24px;
  }

  .max-sm\\:text-md {
    font-size: 16px;
  }

  .max-sm\\:text-sm {
    font-size: 14px;
  }

  .max-sm\\:text-xs {
    font-size: 12px;
  }

  .max-sm\\:leading-\\[21px\\] {
    line-height: 21px;
  }

  .max-sm\\:shadow-\\[0px_9px_0px_0px_\\#282661\\] {
    --tw-shadow: 0px 9px 0px 0px #282661;
    --tw-shadow-colored: 0px 9px 0px 0px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }
}

@media (max-width: 400px) {

  .max-\\[400px\\]\\:-mb-\\[19px\\] {
    margin-bottom: -19px;
  }

  .max-\\[400px\\]\\:max-w-\\[240px\\] {
    max-width: 240px;
  }
}

@media (max-width: 300px) {

  .max-\\[300px\\]\\:hidden {
    display: none;
  }
}

@media (min-width: 640px) {

  .sm\\:hidden {
    display: none;
  }

  .sm\\:w-1\\/3 {
    width: 33.333333%;
  }

  .sm\\:w-2\\/3 {
    width: 66.666667%;
  }
}

@media (min-width: 743px) {

  .md\\:col-span-1 {
    grid-column: span 1 / span 1;
  }

  .md\\:mb-0 {
    margin-bottom: 0px;
  }

  .md\\:ml-\\[14px\\] {
    margin-left: 14px;
  }

  .md\\:mr-16 {
    margin-right: 4rem;
  }

  .md\\:mr-2 {
    margin-right: 0.5rem;
  }

  .md\\:mr-4 {
    margin-right: 1rem;
  }

  .md\\:mr-8 {
    margin-right: 2rem;
  }

  .md\\:mr-\\[16px\\] {
    margin-right: 16px;
  }

  .md\\:mt-\\[19px\\] {
    margin-top: 19px;
  }

  .md\\:inline {
    display: inline;
  }

  .md\\:flex {
    display: flex;
  }

  .md\\:inline-flex {
    display: inline-flex;
  }

  .md\\:hidden {
    display: none;
  }

  .md\\:h-\\[550px\\] {
    height: 550px;
  }

  .md\\:h-\\[56px\\] {
    height: 56px;
  }

  .md\\:h-\\[70vh\\] {
    height: 70vh;
  }

  .md\\:max-h-\\[104px\\] {
    max-height: 104px;
  }

  .md\\:max-h-\\[97px\\] {
    max-height: 97px;
  }

  .md\\:max-h-full {
    max-height: 100%;
  }

  .md\\:w-1\\/2 {
    width: 50%;
  }

  .md\\:w-\\[24px\\] {
    width: 24px;
  }

  .md\\:w-\\[368px\\] {
    width: 368px;
  }

  .md\\:w-\\[66\\%\\] {
    width: 66%;
  }

  .md\\:w-auto {
    width: auto;
  }

  .md\\:max-w-\\[352px\\] {
    max-width: 352px;
  }

  .md\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:flex-wrap {
    flex-wrap: wrap;
  }

  .md\\:content-center {
    align-content: center;
  }

  .md\\:items-center {
    align-items: center;
  }

  .md\\:justify-end {
    justify-content: flex-end;
  }

  .md\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .md\\:px-\\[24px\\] {
    padding-left: 24px;
    padding-right: 24px;
  }

  .md\\:px-\\[65px\\] {
    padding-left: 65px;
    padding-right: 65px;
  }

  .md\\:py-3 {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .md\\:py-8 {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .md\\:pt-8 {
    padding-top: 2rem;
  }

  .md\\:text-lg {
    font-size: 20px;
  }

  .md\\:text-md {
    font-size: 16px;
  }

  .md\\:text-sm {
    font-size: 14px;
  }

  .md\\:leading-3 {
    line-height: .75rem;
  }

  .md\\:leading-3\\.5 {
    line-height: 14px;
  }

  .md\\:text-primary-navyblue {
    --tw-text-opacity: 1;
    color: rgb(38 34 98 / var(--tw-text-opacity));
  }

  @media not all and (min-width: 1024px) {

    .md\\:max-lg\\:mb-4 {
      margin-bottom: 1rem;
    }

    .md\\:max-lg\\:mt-4 {
      margin-top: 1rem;
    }
  }
}

@media not all and (min-width: 1024px) {

  @media (min-width: 743px) {

    .max-lg\\:md\\:\\!pl-12 {
      padding-left: 3rem !important;
    }

    .max-lg\\:md\\:\\!pr-16 {
      padding-right: 4rem !important;
    }
  }
}

@media (min-width: 1024px) {

  .lg\\:fixed {
    position: fixed;
  }

  .lg\\:bottom-0 {
    bottom: 0px;
  }

  .lg\\:bottom-7 {
    bottom: 1.75rem;
  }

  .lg\\:left-0 {
    left: 0px;
  }

  .lg\\:left-\\[38px\\] {
    left: 38px;
  }

  .lg\\:z-0 {
    z-index: 0;
  }

  .lg\\:mx-6 {
    margin-left: 1.5rem;
    margin-right: 1.5rem;
  }

  .lg\\:mb-10 {
    margin-bottom: 2.5rem;
  }

  .lg\\:mb-2 {
    margin-bottom: 0.5rem;
  }

  .lg\\:mb-4 {
    margin-bottom: 1rem;
  }

  .lg\\:mb-6 {
    margin-bottom: 1.5rem;
  }

  .lg\\:mb-8 {
    margin-bottom: 2rem;
  }

  .lg\\:mb-\\[16px\\] {
    margin-bottom: 16px;
  }

  .lg\\:ml-6 {
    margin-left: 1.5rem;
  }

  .lg\\:ml-\\[30px\\] {
    margin-left: 30px;
  }

  .lg\\:ml-auto {
    margin-left: auto;
  }

  .lg\\:mr-\\[27px\\] {
    margin-right: 27px;
  }

  .lg\\:mt-\\[-70px\\] {
    margin-top: -70px;
  }

  .lg\\:flex {
    display: flex;
  }

  .lg\\:\\!hidden {
    display: none !important;
  }

  .lg\\:hidden {
    display: none;
  }

  .lg\\:\\!h-\\[34px\\] {
    height: 34px !important;
  }

  .lg\\:h-\\[100px\\] {
    height: 100px;
  }

  .lg\\:h-\\[16px\\] {
    height: 16px;
  }

  .lg\\:h-\\[88px\\] {
    height: 88px;
  }

  .lg\\:h-\\[calc\\(100vh-700px\\)\\] {
    height: calc(100vh - 700px);
  }

  .lg\\:h-\\[calc\\(100vh-96px\\)\\] {
    height: calc(100vh - 96px);
  }

  .lg\\:max-h-\\[116px\\] {
    max-height: 116px;
  }

  .lg\\:max-h-\\[123px\\] {
    max-height: 123px;
  }

  .lg\\:max-h-\\[143px\\] {
    max-height: 143px;
  }

  .lg\\:\\!w-full {
    width: 100% !important;
  }

  .lg\\:w-3\\/12 {
    width: 25%;
  }

  .lg\\:w-9\\/12 {
    width: 75%;
  }

  .lg\\:w-\\[340px\\] {
    width: 340px;
  }

  .lg\\:w-\\[400px\\] {
    width: 400px;
  }

  .lg\\:min-w-\\[343px\\] {
    min-width: 343px;
  }

  .lg\\:min-w-\\[536px\\] {
    min-width: 536px;
  }

  .lg\\:max-w-\\[340px\\] {
    max-width: 340px;
  }

  .lg\\:max-w-\\[417px\\] {
    max-width: 417px;
  }

  .lg\\:flex-col {
    flex-direction: column;
  }

  .lg\\:flex-wrap {
    flex-wrap: wrap;
  }

  .lg\\:justify-center {
    justify-content: center;
  }

  .lg\\:gap-4 {
    gap: 1rem;
  }

  .lg\\:gap-6 {
    gap: 1.5rem;
  }

  .lg\\:overflow-y-auto {
    overflow-y: auto;
  }

  .lg\\:bg-neutral-whiteboard {
    --tw-bg-opacity: 1;
    background-color: rgb(250 251 253 / var(--tw-bg-opacity));
  }

  .lg\\:p-4 {
    padding: 1rem;
  }

  .lg\\:px-5 {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .lg\\:px-\\[8\\.33\\%\\] {
    padding-left: 8.33%;
    padding-right: 8.33%;
  }

  .lg\\:py-4 {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .lg\\:pb-0 {
    padding-bottom: 0px;
  }

  .lg\\:pb-6 {
    padding-bottom: 1.5rem;
  }

  .lg\\:pt-10 {
    padding-top: 2.5rem;
  }

  .lg\\:text-md {
    font-size: 16px;
  }

  .lg\\:text-sm {
    font-size: 14px;
  }

  .lg\\:text-xl {
    font-size: 24px;
  }

  .lg\\:font-bold {
    font-weight: 700;
  }

  .lg\\:\\!leading-\\[19px\\] {
    line-height: 19px !important;
  }

  .lg\\:\\!leading-\\[22px\\] {
    line-height: 22px !important;
  }

  .lg\\:leading-\\[19px\\] {
    line-height: 19px;
  }

  .lg\\:leading-\\[22px\\] {
    line-height: 22px;
  }

  .lg\\:text-primary-navyblue {
    --tw-text-opacity: 1;
    color: rgb(38 34 98 / var(--tw-text-opacity));
  }
}

.\\[\\&\\>\\.account-menu-group\\>\\.account-menu-item-container\\>a\\>div\\.account-menu-item\\]\\:\\!ml-0>.account-menu-group>.account-menu-item-container>a>div.account-menu-item {
  margin-left: 0px !important;
}

.\\[\\&\\>\\.account-menu-group\\>p\\]\\:\\!ml-4>.account-menu-group>p {
  margin-left: 1rem !important;
}

.\\[\\&\\>div\\.carousel\\>div\\.flickity-viewport\\]\\:\\!h-\\[320px\\]>div.carousel>div.flickity-viewport {
  height: 320px !important;
}

.\\[\\&\\>div\\.carousel\\]\\:\\!mb-5>div.carousel {
  margin-bottom: 1.25rem !important;
}

.\\[\\&\\>div\\>\\.shadow-div\\]\\:h-\\[20px\\]>div>.shadow-div {
  height: 20px;
}

.\\[\\&\\>div\\>input\\]\\:h-12>div>input {
  height: 3rem;
}

.\\[\\&\\>div\\>input\\]\\:h-\\[48px\\]>div>input {
  height: 48px;
}

.\\[\\&\\>div\\>input\\]\\:border-0>div>input {
  border-width: 0px;
}

.\\[\\&\\>div\\>input\\]\\:bg-neutral-notebook\\/\\[0\\.5\\]>div>input {
  background-color: rgb(220 227 239 / 0.5);
}

.\\[\\&\\>div\\]\\:flex>div {
  display: flex;
}

.\\[\\&\\>div\\]\\:items-center>div {
  align-items: center;
}

.\\[\\&\\>div\\]\\:justify-center>div {
  justify-content: center;
}

.\\[\\&\\>input\\]\\:w-full>input {
  width: 100%;
}

.\\[\\&\\>input\\]\\:\\!rounded-lg>input {
  border-radius: 0.5rem !important;
}

.\\[\\&\\>input\\]\\:border-0>input {
  border-width: 0px;
}

.\\[\\&\\>input\\]\\:bg-neutral-notebook\\/\\[0\\.5\\]>input {
  background-color: rgb(220 227 239 / 0.5);
}

.\\[\\&\\>input\\]\\:\\!pr-16>input {
  padding-right: 4rem !important;
}

.\\[\\&\\>label\\>div\\>svg\\]\\:\\!h-6>label>div>svg {
  height: 1.5rem !important;
}

.\\[\\&\\>span\\:last-child\\]\\:block>span:last-child {
  display: block;
}

.\\[\\&\\>span\\:last-child\\]\\:truncate>span:last-child {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.\\[\\&\\>span\\:last-child\\]\\:text-ellipsis>span:last-child {
  text-overflow: ellipsis;
}

.\\[\\&\\>span\\]\\:\\!leading-4>span {
  line-height: 1rem !important;
}

.\\[\\&\\>td\\]\\:py-2>td {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.\\[\\&\\>th\\]\\:bg-neutral-sketchbook>th {
  --tw-bg-opacity: 1;
  background-color: rgb(244 247 252 / var(--tw-bg-opacity));
}

.\\[\\&\\>th\\]\\:py-2>th {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.\\[\\&_input\\]\\:h-12 input {
  height: 3rem;
}

.\\[\\&_input\\]\\:\\!border input {
  border-width: 1px !important;
}

.\\[\\&_input\\]\\:px-4 input {
  padding-left: 1rem;
  padding-right: 1rem;
}

.\\[\\&_input\\]\\:py-3 input {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.\\[\\&_p\\]\\:flex p {
  display: flex;
}

.\\[\\&_p\\]\\:items-center p {
  align-items: center;
}

.\\[\\&_p\\]\\:justify-start p {
  justify-content: flex-start;
}

.\\[\\&_p\\]\\:text-neutral-whiteboard p {
  --tw-text-opacity: 1;
  color: rgb(250 251 253 / var(--tw-text-opacity));
}

.\\[\\&_span\\]\\:ml-auto span {
  margin-left: auto;
}

.\\[\\&_span\\]\\:pl-1 span {
  padding-left: 0.25rem;
}

.\\[\\&_span\\]\\:font-bold span {
  font-weight: 700;
}

.\\[\\&_span\\]\\:text-neutral-pencil span {
  --tw-text-opacity: 1;
  color: rgb(81 81 81 / var(--tw-text-opacity));
}

.\\[\\&_svg\\:first-of-type\\]\\:hidden svg:first-of-type {
  display: none;
}

.\\[\\&_svg\\]\\:h-\\[24px\\] svg {
  height: 24px;
}

.\\[\\&_svg\\]\\:w-\\[21px\\] svg {
  width: 21px;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;CAA0B,CAA1B;;;CAA0B;;AAA1B;;;EAAA,sBAA0B,EAA1B,MAA0B;EAA1B,eAA0B,EAA1B,MAA0B;EAA1B,mBAA0B,EAA1B,MAA0B;EAA1B,qBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;EAAA,gBAA0B;AAAA;;AAA1B;;;;;;;CAA0B;;AAA1B;EAAA,gBAA0B,EAA1B,MAA0B;EAA1B,8BAA0B,EAA1B,MAA0B;EAA1B,gBAA0B,EAA1B,MAA0B;EAA1B,cAA0B;KAA1B,WAA0B,EAA1B,MAA0B;EAA1B,4NAA0B,EAA1B,MAA0B;EAA1B,6BAA0B,EAA1B,MAA0B;EAA1B,+BAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;;CAA0B;;AAA1B;EAAA,SAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;;;CAA0B;;AAA1B;EAAA,SAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;EAA1B,qBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,yCAA0B;UAA1B,iCAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;;;;;EAAA,kBAA0B;EAA1B,oBAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,cAA0B;EAA1B,wBAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,mBAA0B;AAAA;;AAA1B;;;;;CAA0B;;AAA1B;;;;EAAA,+GAA0B,EAA1B,MAA0B;EAA1B,6BAA0B,EAA1B,MAA0B;EAA1B,+BAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,cAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,cAA0B;EAA1B,cAA0B;EAA1B,kBAA0B;EAA1B,wBAA0B;AAAA;;AAA1B;EAAA,eAA0B;AAAA;;AAA1B;EAAA,WAA0B;AAAA;;AAA1B;;;;CAA0B;;AAA1B;EAAA,cAA0B,EAA1B,MAA0B;EAA1B,qBAA0B,EAA1B,MAA0B;EAA1B,yBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;;;CAA0B;;AAA1B;;;;;EAAA,oBAA0B,EAA1B,MAA0B;EAA1B,8BAA0B,EAA1B,MAA0B;EAA1B,gCAA0B,EAA1B,MAA0B;EAA1B,eAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;EAA1B,SAA0B,EAA1B,MAA0B;EAA1B,UAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,oBAA0B;AAAA;;AAA1B;;;CAA0B;;AAA1B;;;;EAAA,0BAA0B,EAA1B,MAA0B;EAA1B,6BAA0B,EAA1B,MAA0B;EAA1B,sBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,aAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,gBAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,wBAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,YAA0B;AAAA;;AAA1B;;;CAA0B;;AAA1B;EAAA,6BAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,wBAA0B;AAAA;;AAA1B;;;CAA0B;;AAA1B;EAAA,0BAA0B,EAA1B,MAA0B;EAA1B,aAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,kBAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;;;;;;;;;;;;EAAA,SAA0B;AAAA;;AAA1B;EAAA,SAA0B;EAA1B,UAA0B;AAAA;;AAA1B;EAAA,UAA0B;AAAA;;AAA1B;;;EAAA,gBAA0B;EAA1B,SAA0B;EAA1B,UAA0B;AAAA;;AAA1B;;CAA0B;AAA1B;EAAA,UAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,gBAA0B;AAAA;;AAA1B;;;CAA0B;;AAA1B;EAAA,UAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;EAAA,UAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,eAA0B;AAAA;;AAA1B;;CAA0B;AAA1B;EAAA,eAA0B;AAAA;;AAA1B;;;;CAA0B;;AAA1B;;;;;;;;EAAA,cAA0B,EAA1B,MAA0B;EAA1B,sBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,eAA0B;EAA1B,YAA0B;AAAA;;AAA1B,wEAA0B;AAA1B;EAAA,aAA0B;AAAA;;AAA1B;EAAA,wBAA0B;EAA1B,wBAA0B;EAA1B,mBAA0B;EAA1B,mBAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,eAA0B;EAA1B,eAA0B;EAA1B,aAA0B;EAA1B,aAA0B;EAA1B,kBAA0B;EAA1B,sCAA0B;EAA1B,8BAA0B;EAA1B,6BAA0B;EAA1B,4BAA0B;EAA1B,eAA0B;EAA1B,oBAA0B;EAA1B,sBAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,kBAA0B;EAA1B,2BAA0B;EAA1B,4BAA0B;EAA1B,sCAA0B;EAA1B,kCAA0B;EAA1B,2BAA0B;EAA1B,sBAA0B;EAA1B,8BAA0B;EAA1B,YAA0B;EAA1B,kBAA0B;EAA1B,gBAA0B;EAA1B,iBAA0B;EAA1B,kBAA0B;EAA1B,cAA0B;EAA1B,gBAA0B;EAA1B,aAA0B;EAA1B,mBAA0B;EAA1B,qBAA0B;EAA1B,2BAA0B;EAA1B,yBAA0B;EAA1B,0BAA0B;EAA1B,2BAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,yBAA0B;EAA1B;AAA0B;;AAA1B;EAAA,wBAA0B;EAA1B,wBAA0B;EAA1B,mBAA0B;EAA1B,mBAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,eAA0B;EAA1B,eAA0B;EAA1B,aAA0B;EAA1B,aAA0B;EAA1B,kBAA0B;EAA1B,sCAA0B;EAA1B,8BAA0B;EAA1B,6BAA0B;EAA1B,4BAA0B;EAA1B,eAA0B;EAA1B,oBAA0B;EAA1B,sBAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,kBAA0B;EAA1B,2BAA0B;EAA1B,4BAA0B;EAA1B,sCAA0B;EAA1B,kCAA0B;EAA1B,2BAA0B;EAA1B,sBAA0B;EAA1B,8BAA0B;EAA1B,YAA0B;EAA1B,kBAA0B;EAA1B,gBAA0B;EAA1B,iBAA0B;EAA1B,kBAA0B;EAA1B,cAA0B;EAA1B,gBAA0B;EAA1B,aAA0B;EAA1B,mBAA0B;EAA1B,qBAA0B;EAA1B,2BAA0B;EAA1B,yBAA0B;EAA1B,0BAA0B;EAA1B,2BAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,yBAA0B;EAA1B;AAA0B;AAC1B;EAAA;AAAgC;AAAhC;;EAAA;IAAA;EAAgC;AAAA;AAAhC;;EAAA;IAAA;EAAgC;AAAA;AAAhC;;EAAA;IAAA;EAAgC;AAAA;AAAhC;;EAAA;IAAA;EAAgC;AAAA;AAAhC;;EAAA;IAAA;EAAgC;AAAA;AAChC;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B,oBAA+B;EAA/B,4BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,mCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,wBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,2BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,qBAA+B;OAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B,uBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,gCAA+B;EAA/B;AAA+B;AAA/B;EAAA,8BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,4BAA+B;EAA/B;AAA+B;AAA/B;EAAA,4BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,6BAA+B;UAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;KAA/B;AAA+B;AAA/B;EAAA,mBAA+B;KAA/B;AAA+B;AAA/B;EAAA,+BAA+B;KAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,4BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA,2BAA+B;EAA/B;AAA+B;AAA/B;EAAA,8BAA+B;EAA/B;AAA+B;AAA/B;EAAA,8BAA+B;EAA/B;AAA+B;AAA/B;EAAA,4BAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,mCAA+B;EAA/B,wDAA+B;EAA/B;AAA+B;AAA/B;EAAA,oDAA+B;EAA/B,4DAA+B;EAA/B;AAA+B;AAA/B;EAAA,qCAA+B;EAA/B,4DAA+B;EAA/B;AAA+B;AAA/B;EAAA,oCAA+B;EAA/B,2DAA+B;EAA/B;AAA+B;AAA/B;EAAA,uCAA+B;EAA/B,8DAA+B;EAA/B;AAA+B;AAA/B;EAAA,+EAA+B;EAA/B,mGAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,iGAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,2GAA+B;EAA/B,yGAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sCAA+B;EAA/B,0RAA+B;UAA/B;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B,+QAA+B;UAA/B;AAA+B;AAA/B;EAAA,gKAA+B;EAA/B,wJAA+B;EAA/B,iLAA+B;EAA/B,wDAA+B;EAA/B;AAA+B;AAA/B;EAAA,wBAA+B;EAA/B,wDAA+B;EAA/B;AAA+B;;AAG/B;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT;yBACuB;EACvB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;aACW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,yBAAkB;KAAlB,sBAAkB;UAAlB,iBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAlEA;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA,0BAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED,kBAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA,oBAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED,0BAkEC;EAlED;AAkEC;;AAlED;EAAA,6BAkEC;EAlED,6BAkEC;EAlED;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA,kBAkEC;EAlED;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA,kBAkEC;EAlED;AAkEC;;AAlED;EAAA,oBAkEC;EAlED;AAkEC;;AAlED;EAAA,oBAkEC;EAlED;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA,kBAkEC;EAlED;AAkEC;;AAlED;;EAAA;IAAA;EAkEC;;EAlED;IAAA,gCAkEC;IAlED;EAkEC;AAAA;;AAlED;;EAAA;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA,iBAkEC;IAlED;EAkEC;;EAlED;IAAA,gBAkEC;IAlED;EAkEC;;EAlED;IAAA,gBAkEC;IAlED;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA,wBAkEC;IAlED;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA,sBAkEC;IAlED;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA,6BAkEC;IAlED;EAkEC;;EAlED;IAAA,kBAkEC;IAlED;EAkEC;;EAlED;IAAA,qBAkEC;IAlED;EAkEC;;EAlED;IAAA,mBAkEC;IAlED;EAkEC;;EAlED;IAAA,iBAkEC;IAlED;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA,oBAkEC;IAlED;EAkEC;;EAlED;IAAA,0BAkEC;IAlED;EAkEC;;EAlED;IAAA,6BAkEC;IAlED,6BAkEC;IAlED;EAkEC;AAAA;;AAlED;;EAAA;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA,iBAkEC;IAlED;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA,sBAkEC;IAlED;EAkEC;;EAlED;IAAA,sBAkEC;IAlED;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA,kBAkEC;IAlED;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA,4BAkEC;IAlED;EAkEC;;EAlED;IAAA,+BAkEC;IAlED;EAkEC;;EAlED;IAAA,kBAkEC;IAlED;EAkEC;;EAlED;IAAA,kBAkEC;IAlED;EAkEC;;EAlED;IAAA,oBAkEC;IAlED;EAkEC;;EAlED;IAAA,mBAkEC;IAlED;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA,oBAkEC;IAlED;EAkEC;;EAlED;IAAA,0BAkEC;IAlED;EAkEC;AAAA;;AAlED;;EAAA;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA,gBAkEC;IAlED;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA,kBAkEC;IAlED;EAkEC;;EAlED;IAAA,kBAkEC;IAlED;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA,oCAkEC;IAlED,2DAkEC;IAlED;EAkEC;AAAA;;AAlED;;EAAA;IAAA;EAkEC;;EAlED;IAAA;EAkEC;AAAA;;AAlED;;EAAA;IAAA;EAkEC;AAAA;;AAlED;;EAAA;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;AAAA;;AAlED;;EAAA;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA,oBAkEC;IAlED;EAkEC;;EAlED;IAAA,kBAkEC;IAlED;EAkEC;;EAlED;IAAA,kBAkEC;IAlED;EAkEC;;EAlED;IAAA,oBAkEC;IAlED;EAkEC;;EAlED;IAAA,iBAkEC;IAlED;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA,oBAkEC;IAlED;EAkEC;;EAlED;;IAAA;MAAA;IAkEC;;IAlED;MAAA;IAkEC;EAAA;AAAA;;AAlED;;EAAA;;IAAA;MAAA;IAkEC;;IAlED;MAAA;IAkEC;EAAA;AAAA;;AAlED;;EAAA;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA,mBAkEC;IAlED;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA,kBAkEC;IAlED;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA,qBAkEC;IAlED;EAkEC;;EAlED;IAAA,mBAkEC;IAlED;EAkEC;;EAlED;IAAA,iBAkEC;IAlED;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA,oBAkEC;IAlED;EAkEC;AAAA;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA,gBAkEC;EAlED,uBAkEC;EAlED;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA,mBAkEC;EAlED;AAkEC;;AAlED;EAAA,kBAkEC;EAlED;AAkEC;;AAlED;EAAA,mBAkEC;EAlED;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA,kBAkEC;EAlED;AAkEC;;AAlED;EAAA,oBAkEC;EAlED;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA,oBAkEC;EAlED;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA,oBAkEC;EAlED;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC","sourcesContent":["@import \"tailwindcss/base\";\n@import \"tailwindcss/components\";\n@import \"tailwindcss/utilities\";\n@import \"src/assets/css/animation.css\";\n\n::-webkit-scrollbar {\n  width: 4px;\n}\n::-webkit-scrollbar-track {\n  color: transparent;\n  width: 4px;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #FFFFFF4d;\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #E5E7EB;\n  border-radius: 4px;\n}\n\nbody {\n  margin: 0;\n  font-family: 'Twemoji Country Flags', 'source-han-sans-simplified-c',\n    sans-serif !important;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\nbody::-webkit-scrollbar {\n  display: none;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n#root {\n  overflow: auto;\n  max-height: 100%;\n  min-height: 100%;\n  @apply select-none;\n}\n\n#root::-webkit-scrollbar {\n  display: none;\n}\n\n.no-scrollbar::-webkit-scrollbar {\n  display: none;\n}\n\n.date-picker input {\n  -webkit-appearance: none;\n  width: 100%\n}\n\n.date-picker input::-webkit-date-and-time-value {\n  text-align: left;\n}\n\n.break-words {\n  word-break: break-word;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
